import {
    useLazyQuery,
    useMutation,
    useQuery,
    useReactiveVar,
} from '@apollo/client'
import {
    ShowGlobalSnackbarMutation,
    ShowGlobalSnackbarMutationProps,
    ShowGlobalSnackbarRequest,
} from '@deltek/specification-client/core/Configurations/GlobalSnackbar'
import { AppBarContext } from '@deltek/specification-client/core/Contexts/AppBarContext'
import NavPrompt from '@deltek/specification-client/core/Forms/NavPrompt'
import { CurrentUserActiveFirmQuery } from '@deltek/specification-client/core/GraphQL/Queries/currentUserInfo.queries'
import { CurrentUserActiveFirmResponse } from '@deltek/specification-client/core/Models/currentUserInfo'
import { ManufacturerProductSpecDocDetail } from '@deltek/specification-client/core/Models/product'
import { ProjectElementNode } from '@deltek/specification-client/core/Models/productListingDetail'
import {
    OMElementLibraryElementType,
    ProjectElementType,
} from '@deltek/specification-client/core/Models/projectElement'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { updateKpMainLocalStore } from '@deltek/specification-client/core/Utilities/localstorageUtils'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import {
    PickerFileMetadata,
    PickerResponse,
} from '@deltek/specification-client/core/Widgets/Filestack/FilestackButton'
import { Button, Tab, Tabs, Typography } from '@material-ui/core'
import Backdrop from '@material-ui/core/Backdrop/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Theme, makeStyles } from '@material-ui/core/styles'
import {
    BPImportDeleteImportedFamilyMutation,
    ExecuteImportProjectProductFamily,
    ImportDiscardFileMutation,
} from 'api/graphQL/mutations/projectImport.mutations'
import {
    DeletePublishedImportedProductFamilyMutation,
    PublishFamilyMutation,
} from 'api/graphQL/mutations/studioManagement.mutations'
import { GetProjectElementNodesQuery } from 'api/graphQL/queries/projectElements.queries'
import {
    CheckForDuplicateAssociationQuery,
    CheckForDuplicateFileQuery,
    DuplicateImportedFamilies,
    GetDuplicateOfficeMasterImportedFamilies,
    GetImportFilesQuery,
    GetMasterSpecTemplateQuery,
    GetProductFamilyPreviewQuery,
    GetProductTypePreviewQuery,
    ImportFileExtractionQuery,
    MatchAssemblyAssociationsWithExistingVersionsQuery,
} from 'api/graphQL/queries/projectImport.queries'
import { userInfo } from 'api/graphQL/reactiveVars/user'
import {
    TableList,
    contentTeamProjectId,
    isReactiveContentTeamFromStudioPage,
} from 'api/graphQL/reactiveVars/workspaceContent'
import {
    CheckDuplicateFilesForImport,
    ExecuteImportData,
    Families,
    UploadFilesForImport,
} from 'api/graphQL/types/project.types'
import { GetProjectElementNodesResponse } from 'api/graphQL/types/projectElement.types'
import { PublishResult } from 'bpm/models/contentManagement'
import clsx from 'clsx'
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import { processEnv } from 'components/configuration/environmentVariables'
import {
    DeletePublishedProductFamilyInfoInput,
    DeletePublishedProductFamilyInfoResponse,
    PublishProductFamilyInfo,
} from 'models/StudioManagement/studioManagement'
import {
    CheckAssemblyAssociationsInput,
    DuplicateImportedFamilyInput,
    GetDuplicateImportedFamiliesInput,
    GetProjectElementNodesInput,
    assemblyAssociationInputs,
} from 'models/getProjectElementNodesInput'
import {
    CheckAssemblyAssociationsResponse,
    CheckForDuplicateFilesInAssemblyInput,
    DiscardFileInput,
    DiscardFileResponse,
    DuplicateImportPathResponse,
    DuplicateOfficeMasterImportedFamiliesResponse,
    DuplicatePath,
    DuplicateTreePathResponse,
    ExecuteImportInfo,
    GetImoprtedFilesResponse,
    GetMasterSpecTemplateResponse,
    ImportFileUploadInput,
    ImportGuideInfo,
    ImportPagePreviewResponse,
    ImportUploadFileInfo,
    ProjectProductFamilyFileInput,
} from 'models/projectImport'
import { ProjectSettings } from 'models/projectSettings'
import { StudioContext } from 'pages/StudioPage/common/StudioContext'
import React from 'react'
import { useParams } from 'react-router-dom'
import { Row } from 'react-table'
import { downloadBase64DataAsZip } from 'shared/utils/fileUtils'
import { setNestedObjectPropertyValue } from 'shared/utils/objectUtils'
import {
    getFromLocalStorage,
    getLocalStorageValue,
    localStorageItemKey,
    localStorageKey,
} from 'shared/utils/workspaceUtils'
import { ProjectPageContext } from '../ProjectPage/components/ProjectPageContext'
import {
    addWorkResultItemsOnFamilies,
    getFilteredParagraphForPreview,
    shortedImportTableData,
} from '../WorkspacePage/components/Common/utils'
import { defaultProjSettings } from '../projectUtils'
import { ImportDocumentRow } from './components/ImportDocuments/ImportDocumentRow'
import ImportDuplicateVersionDialog from './components/ImportDuplicateVersion/ImportDuplicateVersionDialog'
import ImportGuidePage from './components/ImportGuidePage/ImportGuidePage'
import ImportIssuesDialog from './components/ImportIssuesDialog'
import ImportBPHeader from './components/ImportPageActionBar/ImportBPHeader'
import ImportPageActionBar, {
    ImportPageActionBarWidget,
} from './components/ImportPageActionBar/ImportPageActionBar'
import ImportPageTable from './components/ImportPageTable/ImportPageTable'
import ImportPreviewSection from './components/ImportPreviewSection/ImportPreviewSection'
import ImportExecutionProgress from './components/ImportProgress/ImportExecutionProgress'
import SetAssociations from './components/SetAssociations/SetAssociations'

export interface ParagraphChild {
    logType: string
    text: string
}

export interface FilteredParagraphData {
    text: string
    children?: ParagraphChild[]
}

export interface ErrorsType {
    family: string
    values: (string | FilteredParagraphData)[]
    type: string
    message?: string
    expanded: boolean
    backConvertedDiffDocxUri?: string | null
}
const a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
        'data-testid': `customTab${index}`,
    }
}
const useStyle = makeStyles((theme: Theme) => ({
    container: {
        height: `100%`,
    },
    workspaceButton: {
        borderRadius: 100,
        fontSize: pxToRem(12),
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: (props: ImportPageProps) =>
                props?.isBPImport ? theme.palette.common.white : '#33AEA6',
            color: (props: ImportPageProps) =>
                props?.isBPImport
                    ? theme.palette.common.black
                    : theme.palette.common.white,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        },
    },
    workspaceButtonDisabled: {
        borderRadius: 100,
        fontSize: pxToRem(12),
        backgroundColor: '#ffffffa6 !important',
        '&:hover': {
            backgroundColor: '#33AEA6',
            color: theme.palette.common.white,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        },
    },
    projectImportContainer: {
        width: 'calc(100% + 48px)',
        backgroundColor: (props: ImportPageProps) =>
            props?.isBPImport ? '#f2f4f6' : '#f2f2f2',
        marginLeft: theme.spacing(-3),
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        [theme.breakpoints.between('lg', 'md')]: {
            flexDirection: 'column',
        },
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
        flex: 1,

        [theme.breakpoints.up(theme.breakpoints.values.xl + 1)]: {
            marginLeft: 0,
            width: '100%',
        },
        [theme.breakpoints.down('lg')]: {
            justifyContent: 'space-between',
        },
        padding: 0,
    },
    projectTeamContainer: {
        backgroundColor: theme.palette.primary.main,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: theme.palette.common.white,
    },
    specTable: {
        overflow: 'hidden',
    },
    overRideContainer: {
        fontSize: pxToRem(14),
        color: '#0000008A',
    },
    overRideHeading: {
        margin: theme.spacing(0.625),
        marginBottom: theme.spacing(2),
        marginTop: 0,
    },
    overRideHeadingImportTop: {
        margin: theme.spacing(0.625),
        marginBottom: theme.spacing(2),
        marginTop: 0,
        color: theme.palette.common.black,
    },
    overRideHeadingImportBottom: {
        margin: theme.spacing(0.625),
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
        color: theme.palette.common.black,
    },
    overRideHeadingImport: {
        margin: theme.spacing(0.625),
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2.5),
        color: theme.palette.common.black,
    },
    overRideText: {
        color: '#0000008A',
        fontWeight: 500,
        margin: theme.spacing(0.625),
        paddingLeft: theme.spacing(2.5),
    },
    overRideFamilies: {
        color: '#0000008A',
        fontWeight: 500,
        borderTop: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid #C7C7C7',
        margin: 0,
    },
    overRideImportHeading: {
        color: '#000000',
        fontWeight: 500,

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid #C7C7C7',
        margin: 0,
    },
    familiyColumn: {
        flex: 1,
        borderRight: '0.5px solid #C7C7C7',
        textAlign: 'center',
        padding: theme.spacing(1),
        marginRight: -theme.spacing(0.125),
    },
    familyColumnAssociation: {
        flex: 0.5,
    },
    assemblyColumn: {
        flex: 1,
        textAlign: 'center',
        padding: theme.spacing(1),
        borderLeft: '0.5px solid #C7C7C7',
    },
    assemblyColumnContent: {
        textAlign: 'left',
    },
    title: {
        padding: theme.spacing(2),
        width: pxToRem(490),
        '@media (max-width: 1025px)': {
            width: pxToRem(455),
        },
    },
    appHeaderRight: {
        width: 'auto',
        marginRight: 0,
        '& .MuiGrid-item': {
            '@media (max-width: 1025px)': {
                padding: theme.spacing(2, 0.9),
            },
        },
    },
    appHeader: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[900],
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        left: 0,
    },
    appHeaderContent: {
        maxWidth: '1920px',
        margin: 'auto',
        gridTemplateColumns: '2fr 7fr',
        display: 'grid',
        alignItems: 'center',
        '& h1': {
            '@media (max-width: 1025px)': {
                fontSize: pxToRem(20),
            },
        },
    },
    importDetailsWrapper: {
        maxWidth: (props: ImportPageProps) => (props.isBPImport ? 730 : '100%'),
        flex: 2.5,
        margin: (props: ImportPageProps) =>
            theme.spacing(
                props.isBPImport
                    ? props.isSelectedFileImported ||
                      props.isSelectedFileImported === undefined
                        ? 12
                        : 10.5
                    : 3.5,
                3,
                3,
                3
            ),
    },
    tabRoot: {
        minHeight: theme.spacing(7),
    },
    tabButtonsRoot: {
        minWidth: theme.spacing(6),
        minHeight: theme.spacing(4.5),
    },
    tabsIndicator: {
        border: 'none',
        height: 0,
    },
    selectedTab: {
        fontSize: pxToRem(14),
        color: '#fff',
        backgroundColor: '#304959',
        borderRadius: theme.spacing(0.5),
    },
}))
export const getDocDetail = (
    docs: Partial<ManufacturerProductSpecDocDetail>[] | undefined,
    docType: 'ShortForm' | 'FullLength'
): Partial<ManufacturerProductSpecDocDetail> | undefined =>
    docs?.filter((each) => each.docType === docType && !!each.path)?.[0]
export interface ImportPageProps {
    isBPImport?: boolean
    isSelectedFileImported?: boolean
}
export interface FilesToPublish {
    productFamilyIdGuid: string
    isPublished: boolean
}
interface ImportParamsProps {
    isForImportOnly?: boolean
    isImportOverwrite?: boolean
    isUpdateProductFamilyAssociation?: boolean
    itemToImport?: (Partial<ImportUploadFileInfo> | undefined)[]
}
export type DocumentType = 'docx' | 'doc' | 'pdf'
export type WarningDialogType = 'Caution' | 'Needs Attention'

const ProjectImportPage: React.FC<ImportPageProps> = ({}) => {
    // remove the env condition when OM Version is production ready
    const isVersionCriteriaEnabled = React.useMemo(
        () => processEnv.REACT_APP_EnableVersionControl === '1',
        [processEnv]
    )

    const [instanceId, setInstanceId] = React.useState<string | null>(null)
    const [previewInstanceId, setPreviewInstanceId] = React.useState<
        string | null
    >(null)
    const [selectedRowType, setSelectedRowType] = React.useState<
        string | undefined
    >()
    const [filesToPublish, setFilesToPublish] = React.useState<
        FilesToPublish[]
    >([])
    const [fileExtractionLoading, setFileExtractionLoading] = React.useState<
        boolean
    >(false)
    const [
        selectedProductTypeName,
        setSelectedProductTypeName,
    ] = React.useState<string | undefined>()
    const [projectSettings, setProjectSettings] = React.useState<
        ProjectSettings
    >(defaultProjSettings)
    const [executedInstanceId, setExecutedInstanceId] = React.useState<
        string | null
    >(null)
    const [publishIntanceId, setPublishInstanceId] = React.useState<
        string | null
    >(null)
    const [workResultAssemblyId, setWorkResultAssemblyId] = React.useState<
        string | undefined
    >()
    const [itemToImportFile, setItemToImportFile] = React.useState<
        Partial<PickerFileMetadata>
    >()

    const [duplicateFileInstances, setDuplicateFileInstances] = React.useState<
        string | null
    >(null)
    const [duplicateFilesLoading, setDuplicateFilesLoading] = React.useState<
        boolean
    >(false)
    const [isImportCompleted, setIsImportCompleted] = React.useState<boolean>(
        false
    )

    const [warningDialogType, setWarningDialogType] = React.useState<
        WarningDialogType
    >()
    const [showWarningDialog, setShowWarningDialog] = React.useState<boolean>(
        false
    )
    const [showDuplicateDialog, setShowDuplicateDialog] = React.useState<
        boolean
    >(false)
    const [overrideDialogType, setOverrideDialogType] = React.useState<
        string | undefined
    >()
    const [showOverrideDialog, setShowOverrideDialog] = React.useState<boolean>(
        false
    )
    const [showAssociationDialog, setShowAssociationDialog] = React.useState<
        boolean
    >(false)
    const [
        showEmptyAssociationDialog,
        setShowEmptyAssociationDialog,
    ] = React.useState<boolean>(false)

    const [selectedFile, setSelectedFile] = React.useState<
        Partial<ImportUploadFileInfo> | undefined
    >()

    const [selectedFileForPreview, setSelectedFileForPreview] = React.useState<
        Partial<ImportUploadFileInfo> | undefined
    >()
    const [removeFileData, setRemoveFileData] = React.useState<Row | undefined>(
        undefined
    )
    const [
        showDuplicateImportDialoge,
        setShowDuplicateImportDialouge,
    ] = React.useState<boolean>(false)

    const [errorsToShow, setErrorsToShow] = React.useState<ErrorsType[]>([])
    const [warningsToShow, setWarningsToShow] = React.useState<ErrorsType[]>([])
    const [totalCount, setTotalCount] = React.useState<number>(0)
    const [filesData, setFilesData] = React.useState<
        Partial<UploadFilesForImport> | undefined
    >()
    const [
        showAssociationWarningDialog,
        setShowAssociationWarningDialog,
    ] = React.useState<boolean>(false)

    const [shouldExecuteImport, setShouldExecuteImport] = React.useState(false)
    const [
        importParams,
        setImportParams,
    ] = React.useState<ImportParamsProps | null>(null)

    const [familyVersionsToImport, setFamilyVersionsToImport] = React.useState<
        ProjectElementNode[]
    >([])

    const isImportDisabled = React.useMemo(() => {
        return (
            (filesData?.fileInfo?.filter((item) => item.imported === false)
                ?.length === 0 ||
                filesData === undefined ||
                filesData?.fileInfo?.length === 0 ||
                filesData?.fileInfo?.filter(
                    (item) =>
                        !item?.imported &&
                        item?.paragraphErrors?.some((itemError) =>
                            itemError?.children?.length === 0
                                ? !itemError?.message?.includes(
                                      'Duplicate Key Renamed'
                                  )
                                : itemError?.children?.some(
                                      (importParagraph) =>
                                          !importParagraph?.message?.includes(
                                              'Duplicate Key Renamed'
                                          )
                                  )
                        )
                )?.length !== 0) ??
            false
        )
    }, [filesData])

    const [uploadedPickerData, setUploadedPickerData] = React.useState<
        Partial<PickerResponse> | undefined
    >()
    const [isPublishiedFile, setIsPublishedFile] = React.useState<
        Partial<DuplicateImportPathResponse>[] | null
    >()
    const [
        importedFilesToBePublished,
        setImportedFilesToBePublished,
    ] = React.useState<boolean>(false)
    const [duplicateFamilies, setDuplicateFamilies] = React.useState<
        Partial<ProjectProductFamilyFileInput>[] | undefined
    >()
    const { isBestPracticeEnabled } = useReactiveVar(userInfo)
    const [allUploadedFamilies, setAllUploadedFamilies] = React.useState<
        Partial<Families>[] | undefined
    >()
    const [familiesToReplace, setFamiliesToReplace] = React.useState<
        CheckForDuplicateFilesInAssemblyInput[]
    >([])
    const [familiesToAdd, setFamiliesToAdd] = React.useState<
        CheckForDuplicateFilesInAssemblyInput[]
    >([])
    const duplicateFilesMessage = duplicateFamilies
        ?.map((item) => {
            return item.familyId?.replaceAll(/['"]+/g, '')
        })
        .join(', ')
    const { projectId } = useParams<{ projectId?: string }>()
    const isBPImport = React.useMemo(
        () => projectId === undefined && isBestPracticeEnabled,
        [projectId, isBestPracticeEnabled]
    )
    const elementsContainerType = React.useMemo(
        () => (isBPImport ? 'Element Library' : 'Project Workspace'),
        [isBPImport]
    )
    const classes = useStyle({
        isBPImport: isBPImport,
        isSelectedFileImported: selectedFile?.imported,
    })

    const {
        data: currentUserActiveFirmResponse,
        loading: currentUserActiveFirmLoading,
    } = useQuery<CurrentUserActiveFirmResponse>(CurrentUserActiveFirmQuery)
    const userId = currentUserActiveFirmResponse?.myActiveFirm?.userId
    const currentProjectId = React.useMemo(() => {
        return isBPImport
            ? currentUserActiveFirmResponse?.myActiveFirm?.bestPracticeProjectId
            : projectId
    }, [projectId, isBPImport, currentUserActiveFirmResponse])
    const firmId = React.useMemo(() => {
        return currentUserActiveFirmResponse?.myActiveFirm?.firmId
    }, [currentUserActiveFirmResponse])
    const isRemovingFileImported = React.useMemo(() => {
        return filesData?.fileInfo?.filter(
            (item) => item?.title === removeFileData?.values?.expander
        )?.[0]?.imported
    }, [removeFileData])
    const [
        selectedFilesAssociations,
        setSelectedFileForAssociation,
    ] = React.useState<CheckForDuplicateFilesInAssemblyInput[]>([])
    const [assemblyAssociation, setAssemblyAssociation] = React.useState<
        Record<string, assemblyAssociationInputs>
    >({})
    const [importPreviewData, setImportPreviewData] = React.useState<
        Partial<ImportPagePreviewResponse>
    >()
    const [filesProgressData, setFilesProgressData] = React.useState<
        Partial<ProjectProductFamilyFileInput>[] | undefined
    >()
    const [overRiddenPaths, setOverRiddenPaths] = React.useState<
        string[] | undefined
    >()
    const [refreshElementPanel, setRefreshElementPanel] = React.useState<
        boolean
    >(false)

    const [showAllFiles, setShowAllFiles] = React.useState<boolean>(false)

    const [showGlobalSnackbar] = useMutation<
        ShowGlobalSnackbarRequest,
        ShowGlobalSnackbarMutationProps
    >(ShowGlobalSnackbarMutation)
    const {
        setCurrentPageTitle,
        setCustomActionBar,
        updateBrowserTitle,
    } = React.useContext(AppBarContext)
    const { setAssemblyStates } = React.useContext(StudioContext)
    const {
        projectData,
        projectLoading,
        setCategoryElementStates,
        setSelectedElementIdentifier,
    } = React.useContext(ProjectPageContext)
    const [filestackLoading, setFilestackLoading] = React.useState<boolean>(
        false
    )
    const [duplicateFileResponse, setDuplicateFileResponse] = React.useState<
        Partial<CheckDuplicateFilesForImport>
    >()

    const [showImportDialog, setShowImportDialog] = React.useState<boolean>(
        false
    )
    const [emptyTableState, setEmptyTableState] = React.useState<boolean>(false)
    const [
        isImportOverwriteSelected,
        setIsImportOverwriteSelected,
    ] = React.useState<boolean>(false)
    const handleShowRemoveDialog = (familyRow: Row) => {
        setRemoveFileData(familyRow)
    }
    const [workresultNodes, setWorkresultNodes] = React.useState<
        GetProjectElementNodesResponse | undefined
    >()
    const [
        importActionBarStateValue,
        setImportActionBarStateValue,
    ] = React.useState<Record<string, any>>({})
    const actionBarCollapsed = React.useMemo(() => {
        return (
            importActionBarStateValue?.showImportActionBarState
                ?.importActionBar ?? false
        )
    }, [importActionBarStateValue])
    const [getElementNodes, { loading: elementsListLoading }] = useLazyQuery<
        GetProjectElementNodesResponse | null,
        Partial<GetProjectElementNodesInput>
    >(GetProjectElementNodesQuery, {
        fetchPolicy: 'no-cache',
        nextFetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
        variables: {
            input: {
                projectId: currentProjectId,
                limit: 1000,
                skip: 0,
                categoryId: '1f689538-1896-41a1-b66b-dd41f71a595a',
                onlyElementsAssignedToProject: false,

                projectElementType: Object.keys(
                    ProjectElementType
                ) as ProjectElementType[],

                parentNodeId: workResultAssemblyId,
            },
        },
        onCompleted: (data: GetProjectElementNodesResponse | null) => {
            if (data?.getProjectElementNodes) {
                setWorkresultNodes(data)
            }
        },
    })

    const { loading: workResultAssemlyLoading } = useQuery<
        GetProjectElementNodesResponse | null,
        Partial<GetProjectElementNodesInput>
    >(GetProjectElementNodesQuery, {
        fetchPolicy: 'no-cache',
        nextFetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
        variables: {
            input: {
                projectId: currentProjectId,
                limit: 1,
                skip: 0,
                categoryId: '1f689538-1896-41a1-b66b-dd41f71a595a',
                onlyElementsAssignedToProject: false,
                projectElementType: Object.keys(
                    ProjectElementType
                ) as ProjectElementType[],

                parentNodeId: 'root',
            },
        },
        onCompleted: (data: GetProjectElementNodesResponse | null) => {
            if (data?.getProjectElementNodes) {
                setWorkResultAssemblyId(
                    data?.getProjectElementNodes?.projectElementNodes?.[0]?.id!
                )
            }
        },
    })

    const fetchTableAndMergeIntoParagraph = React.useCallback(
        (paragraphs, tables) => {
            for (let i = 0; i < paragraphs?.length; i++) {
                if (paragraphs[i].tableIdentifier) {
                    const table = tables.find(
                        (table: Partial<TableList>) =>
                            table.tableIdentifier ===
                            paragraphs[i].tableIdentifier
                    )
                    paragraphs[i].content = {
                        ...table,
                        elements: [
                            ...table.tableHeader, // always push headers first
                            ...table.content,
                        ],
                    }
                }
                if (Array.isArray(paragraphs[i])) {
                    fetchTableAndMergeIntoParagraph(paragraphs[i] ?? [], tables)
                } else {
                    fetchTableAndMergeIntoParagraph(
                        paragraphs[i].children ?? [],
                        tables
                    )
                }
            }
        },
        []
    )

    const setTableIntoParagraph = React.useCallback((data) => {
        const tables = data.sectionPreview?.tables
        if (!tables || tables.length === 0) return data

        const paragraphs = data.sectionPreview?.paragraphs
        fetchTableAndMergeIntoParagraph(paragraphs, tables)
        return { ...data, paragraphs }
    }, [])

    const handleChangePreviewStatus = (
        data: Partial<ImportPagePreviewResponse>
    ) => {
        if (
            data?.sectionPreview?.paragraphs?.filter(
                (item) => item.type === 'Part'
            )?.length === 0 &&
            data?.sectionPreview?.paragraphs?.filter(
                (item) => item.type === 'Article'
            )?.length === 0
        ) {
            setSelectedFileForPreview(undefined)
            setSelectedFile(undefined)
            setSelectedFileForPreview(undefined)
            setImportPreviewData(undefined)
        } else if (
            data?.sectionPreview?.paragraphs?.filter(
                (item) => item.type === 'Part'
            )?.length === 0 &&
            data?.sectionPreview?.paragraphs?.filter(
                (item) => item.type === 'Article'
            )?.length !== 0
        ) {
            const pragraphs = [
                {
                    children:
                        selectedRowType === 'ProductType'
                            ? []
                            : getFilteredParagraphForPreview(
                                  data?.sectionPreview?.paragraphs
                              ),
                    content: [],
                    hierarchicalLevel: 0,
                    index: 0,
                    type: 'Part',
                },
                {
                    children:
                        selectedRowType === 'ProductType'
                            ? getFilteredParagraphForPreview(
                                  data?.sectionPreview?.paragraphs
                              )
                            : [],

                    content: [],
                    hierarchicalLevel: 0,
                    index: 1,
                    type: 'Part',
                },
                {
                    children: [],
                    content: [],
                    hierarchicalLevel: 0,
                    index: 2,
                    type: 'Part',
                },
            ]
            setImportPreviewData({
                ...data,
                sectionPreview: {
                    ...data?.sectionPreview,
                    paragraphs: getFilteredParagraphForPreview(pragraphs),
                },
                fileName: selectedFile?.fileName,
            })
        } else {
            const tableInsertedData = setTableIntoParagraph(data)
            setImportPreviewData({
                ...tableInsertedData,
                fileName: selectedFile?.fileName,
            })
        }
        setPreviewInstanceId(null)
    }

    const [
        getFilePreview,
        { loading: familyPreviewLoading, error: productFamilyPreviewError },
    ] = useLazyQuery<{
        getImportFamilyPreview: Partial<ImportPagePreviewResponse> | null
    }>(GetProductFamilyPreviewQuery(), {
        fetchPolicy: 'no-cache',
        displayName: 'GetProductFamilyPreview',
        onCompleted: (data) => {
            if (
                (data?.getImportFamilyPreview?.sectionPreview?.paragraphs?.filter(
                    (item) => item.type === 'Part'
                )?.length === 0 &&
                    data?.getImportFamilyPreview?.sectionPreview?.paragraphs?.filter(
                        (item) => item.type === 'Article'
                    )?.length === 0) ||
                data?.getImportFamilyPreview?.status?.toLowerCase() === 'error'
            ) {
                data?.getImportFamilyPreview?.errorMessage &&
                    showGlobalSnackbar({
                        variables: {
                            message: data?.getImportFamilyPreview
                                ?.errorMessage!,
                            variant: 'error',
                            id: 'ProjectImportPage_PreviewError',
                        },
                    })
            }
            data?.getImportFamilyPreview &&
                handleChangePreviewStatus(data?.getImportFamilyPreview)
        },
        onError: (err) => {
            setImportPreviewData(undefined)
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ProjectImportPage_UploadFileError',
                },
            })
        },
    })

    const [
        getProductTypePreview,
        { loading: productTypePreviewLoading, error: productTypePreviewError },
    ] = useLazyQuery<{
        getImportedProductTypePreview: Partial<ImportPagePreviewResponse> | null
    }>(GetProductTypePreviewQuery(), {
        fetchPolicy: 'no-cache',
        displayName: 'GetProductTypePreview',
        onCompleted: (data) => {
            if (
                (data?.getImportedProductTypePreview?.sectionPreview?.paragraphs?.filter(
                    (item) => item.type === 'Part'
                )?.length === 0 &&
                    data?.getImportedProductTypePreview?.sectionPreview?.paragraphs?.filter(
                        (item) => item.type === 'Article'
                    )?.length === 0) ||
                data?.getImportedProductTypePreview?.status?.toLowerCase() ===
                    'error'
            ) {
                data?.getImportedProductTypePreview?.errorMessage &&
                    showGlobalSnackbar({
                        variables: {
                            message: data?.getImportedProductTypePreview
                                ?.errorMessage!,
                            variant: 'error',
                            id: 'ProjectImportPage_PreviewError',
                        },
                    })
            }

            data?.getImportedProductTypePreview &&
                handleChangePreviewStatus(data?.getImportedProductTypePreview)
        },
        onError: (err) => {
            setImportPreviewData(undefined)
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ProjectImportPage_UploadFileError',
                },
            })
        },
    })

    const [
        downloadMasterSpecStyleTemplate,
        {
            loading: loadingMasterSpecStyleTemplate,
            error: errorMasterSpecStyleTemplate,
        },
    ] = useLazyQuery<GetMasterSpecTemplateResponse>(
        GetMasterSpecTemplateQuery,
        {
            fetchPolicy: 'no-cache',
            displayName: 'GetMasterSpecTemplate',
            onCompleted: async (data: GetMasterSpecTemplateResponse) => {
                downloadBase64DataAsZip(
                    'MasterSpecStyleTemplate.zip',
                    data?.getMasterSpecTemplate?.masterSpecTemplateDocument
                )
            },
            onError: (err) => {
                showGlobalSnackbar({
                    variables: {
                        message: err.message,
                        variant: 'error',
                        id: 'GetMasterSpecTemplateDownloadError',
                    },
                })
            },
        }
    )

    const [importFilesQuery] = useLazyQuery<{
        getimportFamilyInfoFromFile: Partial<UploadFilesForImport> | null
    }>(ImportFileExtractionQuery, {
        onCompleted: (data) => {
            if (
                data?.getimportFamilyInfoFromFile?.status?.toLowerCase() ===
                'error'
            ) {
                showGlobalSnackbar({
                    variables: {
                        message: data?.getimportFamilyInfoFromFile
                            ?.errorMessage!,
                        variant: 'error',
                        id: 'ProjectImportPage_UploadFileError',
                    },
                })
            } else {
                data?.getimportFamilyInfoFromFile &&
                    handleChangeFileStatus(data?.getimportFamilyInfoFromFile)

                // when some of the files in batch upload has issues and some are successful
                // we want the user to see the family numbers of the files that were discarded
                if (data?.getimportFamilyInfoFromFile?.errorMessage) {
                    showGlobalSnackbar({
                        variables: {
                            message: data?.getimportFamilyInfoFromFile
                                ?.errorMessage!,
                            variant: 'error',
                            id: 'ProjectImportPage_UploadFileError',
                        },
                    })
                }
            }
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message:
                        err?.message ??
                        `There was a problem in uploading files.`,
                    variant: 'error',
                    id: 'ProjectImportPage_UploadFileError',
                },
            })
        },
    })
    const handleClickRemove = React.useCallback(() => {
        const selectedFile = filesData?.fileInfo?.filter(
            (item) => item?.title === removeFileData?.values?.expander
        )?.[0]

        delete assemblyAssociation[selectedFile?.familyId!]

        setAssemblyAssociation(assemblyAssociation)

        const apiCall =
            isBPImport && selectedFile?.imported
                ? discardImportBP
                : discardImport

        apiCall({
            variables: {
                input: {
                    projectId: currentProjectId!,
                    key:
                        !isBPImport || (isBPImport && !selectedFile?.imported)
                            ? selectedFile?.fileKey!
                            : undefined,
                    fileName:
                        !isBPImport || (isBPImport && !selectedFile?.imported)
                            ? selectedFile?.name!
                            : undefined,
                    importedProductFamilyId:
                        isBPImport && selectedFile?.imported
                            ? selectedFile?.familyGuid!
                            : undefined,
                },
            },
        })
    }, [
        isBPImport,
        currentProjectId,
        filesData,
        removeFileData,
        assemblyAssociation,
    ])
    const selectFileData = React.useCallback(
        (fileKey?: string, productTypeName?: string) => {
            const selectedFamily = filesData?.fileInfo?.filter(
                (item) => item?.fileKey === fileKey
            )?.[0]

            setSelectedFileForPreview(selectedFamily)
            setSelectedFile(selectedFamily)
            if (productTypeName) {
                getProductTypePreview({
                    variables: {
                        input: {
                            key: selectedFamily?.fileKey!,
                            fileName:
                                selectedFamily?.fileKey?.split(/_(.*)/s)?.[1] ??
                                '',
                            productType: productTypeName,
                            productTextType: selectedFamily?.productTypeInfo?.filter(
                                (item) => item?.name === productTypeName
                            )?.[0]?.textType,
                            projectId: currentProjectId,
                        },
                    },
                })
            } else {
                if (
                    filesData &&
                    filesData?.fileInfo?.length !== 0 &&
                    selectedFamily?.title !== removeFileData?.values?.expander
                ) {
                    getFilePreview({
                        variables: {
                            input: {
                                key: selectedFamily?.fileKey!,
                                fileName:
                                    selectedFamily?.fileKey?.split(
                                        /_(.*)/s
                                    )?.[1] ?? '',
                                projectId: currentProjectId,
                            },
                        },
                    })
                }
            }
        },
        [filesData, removeFileData, currentProjectId]
    )
    const [executeImport] = useMutation<
        {
            executeImportProjectProductFamily: Partial<ExecuteImportInfo> | null
        },
        { input: ImportFileUploadInput }
    >(ExecuteImportProjectProductFamily, {
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message:
                        err?.message ??
                        `There was a problem in importing files.`,
                    variant: 'error',
                    id: 'ProjectImportPage_UploadFileError',
                },
            })
        },
    })
    const [publishImportedFiles] = useMutation<{
        publishProductFamily: Partial<PublishProductFamilyInfo> | null
    }>(PublishFamilyMutation, {
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: err?.message,
                    variant: 'error',
                    id: 'PublishFamily_Mutation_Error',
                },
            })
        },
    })
    const handleStartExecution = React.useCallback(
        (
            _?: React.MouseEvent<Element, MouseEvent>,
            isForImportOnly?: boolean,
            isUpdateProductFamilyAssociation?: boolean,
            isImportOverwrite?: boolean
        ) => {
            if (isVersionCriteriaEnabled) {
                //when VC is enabled set isImportOverwrite to selected state of overwrite
                isImportOverwrite ??= isImportOverwriteSelected
            }
            setShowDuplicateImportDialouge(false)

            setShowOverrideDialog(false)
            setWarningDialogType(undefined)

            const itemToImport = !isUpdateProductFamilyAssociation
                ? filesData
                    ? filesData?.fileInfo?.filter((item) => !item?.imported)
                    : undefined
                : [selectedFile]

            if (itemToImport) {
                if (isVersionCriteriaEnabled && isBPImport) {
                    // Temporary fix to stop OM users from importing family with custom association
                    setImportParams({
                        isForImportOnly,
                        isImportOverwrite,
                        isUpdateProductFamilyAssociation,
                        itemToImport,
                    })
                    matchAssemblyAssociationsWithExistingVersions({
                        variables: {
                            input: {
                                projectId: currentProjectId!,
                                assemblyAssociationInputs: Object.values(
                                    assemblyAssociation
                                ),
                            },
                        },
                    })
                } else {
                    handleExecuteImport({
                        isForImportOnly,
                        isImportOverwrite,
                        isUpdateProductFamilyAssociation,
                        itemToImport,
                    })
                }
            }
        },
        [
            assemblyAssociation,
            filesData,
            firmId,
            currentProjectId,
            executeImport,
            selectedFile,
            selectedFilesAssociations,
            showDuplicateImportDialoge,
            familyVersionsToImport,
            showAssociationWarningDialog,
            isImportOverwriteSelected,
        ]
    )

    const handleExecuteImport = React.useCallback(
        (currentImportParams: ImportParamsProps) => {
            if (currentImportParams) {
                const {
                    isForImportOnly,
                    isImportOverwrite,
                    isUpdateProductFamilyAssociation,
                    itemToImport,
                } = currentImportParams
                executeImport({
                    variables: {
                        input: {
                            userFiles: itemToImport?.map((item) => {
                                const familyId = item?.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                )
                                const filteredFamilyAssociations =
                                    item?.parentAssemblyTreePaths &&
                                    item?.parentAssemblyTreePaths?.length !==
                                        0 &&
                                    !selectedFile?.selectedProductTypeName
                                        ? item?.associations?.filter(function (
                                              obj
                                          ) {
                                              return (
                                                  !item?.parentAssemblyTreePaths?.includes(
                                                      obj?.treePath?.split(
                                                          `||${familyId}`
                                                      )?.[0]!
                                                  ) ||
                                                  obj?.treePath?.includes(
                                                      'FAMILY GROUP'
                                                  )
                                              )
                                          })
                                        : item?.associations

                                const productTypeAssociations = item?.productTypeInfo
                                    ?.map((itemPT) => {
                                        if (
                                            itemPT?.name?.toLowerCase() ===
                                                selectedFile?.selectedProductTypeName?.toLowerCase() &&
                                            itemPT?.associations?.length === 0
                                        ) {
                                            return
                                        } else {
                                            if (
                                                itemPT?.associations ||
                                                (itemPT?.name ===
                                                    selectedFile?.selectedProductTypeName &&
                                                    isUpdateProductFamilyAssociation &&
                                                    item?.selectedProductTypeName &&
                                                    selectedFilesAssociations)
                                            ) {
                                                const ptAssociations = isUpdateProductFamilyAssociation
                                                    ? [
                                                          ...(itemPT?.associations ??
                                                              [])!,
                                                          ...(item?.associations?.filter(
                                                              (itemIn) =>
                                                                  itemIn
                                                                      ?.productTypeName?.[0] ===
                                                                  itemPT?.name
                                                          ) ?? []),
                                                      ]
                                                    : itemPT?.associations
                                                return {
                                                    associatedTreePath: ptAssociations?.map(
                                                        (itemAssociation) =>
                                                            itemAssociation?.treePath?.split(
                                                                '||' + familyId
                                                            )?.[0] ??
                                                            itemAssociation?.treePath!
                                                    ),
                                                    productTypeName: itemPT?.name!,
                                                }!
                                            }
                                        }
                                    })
                                    ?.filter((item) => item)

                                // get the iteration id of the family to be overwritten. When creating a new version, no iteration id is needed (null)
                                const iterationId = isImportOverwrite
                                    ? familyVersionsToImport.find((x) =>
                                          x.text.includes(item?.familyId ?? '')
                                      )?.iteration?.id
                                    : null

                                return {
                                    ...{
                                        key: item?.fileKey!,
                                        isNewFamily:
                                            !item?.parentAssemblyTreePaths ||
                                            item?.parentAssemblyTreePaths
                                                ?.length === 0,
                                        fileName: item?.fileKey?.split(
                                            /_(.*)/s
                                        )?.[1]!,
                                        addImportedFamilyToWorkResult: item?.imported
                                            ? false
                                            : isForImportOnly,
                                        ...item?.importGuideInfo,
                                        productFamilyAssociation: {
                                            productFamilyAssociations: (selectedFile?.imported &&
                                            !selectedFile?.selectedProductTypeName
                                                ? selectedFilesAssociations
                                                : filteredFamilyAssociations
                                            )
                                                ?.filter(
                                                    (item2) =>
                                                        item2?.elementId !== ''
                                                )
                                                ?.map((itemFamily) => {
                                                    const familyPart = itemFamily?.familyName?.split(
                                                        familyId!
                                                    )
                                                    return {
                                                        parentElementId:
                                                            itemFamily?.elementId,
                                                        productFamilyTreePath:
                                                            itemFamily?.treePath?.split(
                                                                `||${familyId}`
                                                            )?.[0] +
                                                            '||' +
                                                            itemFamily?.familyName?.replace(
                                                                familyId! + ' ',
                                                                `${familyId?.trim()}|`
                                                            ),
                                                    }
                                                })
                                                ?.filter(
                                                    (value, index, self) =>
                                                        index ===
                                                        self.findIndex(
                                                            (fmItem) =>
                                                                fmItem?.productFamilyTreePath ===
                                                                value?.productFamilyTreePath
                                                        )
                                                ),
                                            productTypeAssociations: productTypeAssociations?.map(
                                                (itemPTAssociation) => {
                                                    return {
                                                        ...itemPTAssociation,
                                                        associatedTreePath: itemPTAssociation?.associatedTreePath?.filter(
                                                            (
                                                                value,
                                                                index,
                                                                self
                                                            ) =>
                                                                index ===
                                                                self.findIndex(
                                                                    (ptItem) =>
                                                                        ptItem ===
                                                                        value
                                                                )
                                                        ),
                                                    }
                                                }
                                            ),
                                        }!,
                                    },
                                    ...(isUpdateProductFamilyAssociation && {
                                        isUpdateProductFamilyAssociation: true,
                                    }),

                                    ...(isForImportOnly && {
                                        iterationId,
                                    }),
                                } as ProjectProductFamilyFileInput
                            })! as Partial<ProjectProductFamilyFileInput>,
                            projectId: currentProjectId!,
                            firmId: firmId!,
                        },
                    },
                }).then((response) => {
                    response?.data?.executeImportProjectProductFamily
                        ?.importInstanceId &&
                        setExecutedInstanceId(
                            response?.data?.executeImportProjectProductFamily
                                ?.importInstanceId
                        )
                })
            }
        },
        [
            importParams,
            firmId,
            currentProjectId,
            executeImport,
            selectedFile,
            selectedFilesAssociations,
            familyVersionsToImport,
            isVersionCriteriaEnabled,
        ]
    )

    // block to execute OM import after checking assosciations
    // TODO: remove this after the vc import association pbi is done
    // and move this into handleStartExecution function
    React.useEffect(() => {
        if (shouldExecuteImport && importParams) {
            handleExecuteImport(importParams)
        }
    }, [shouldExecuteImport, importParams])

    /* -----------------------------------------------------------------------------------------------------------------
     * *********************Delete the blocks below once version criteria is production ready**************************
     * -----------------------------------------------------------------------------------------------------------------
     */

    const [checkForDuplicateImportedFamilies] = useLazyQuery<{
        getDuplicateImportedFamilies: Partial<DuplicateImportPathResponse>[]
    }>(DuplicateImportedFamilies, {
        fetchPolicy: 'no-cache',
        displayName: 'GetDuplicateFileResponse',
        onCompleted: (data) => {
            if (
                data?.getDuplicateImportedFamilies &&
                data?.getDuplicateImportedFamilies?.length !== 0
            ) {
                setIsPublishedFile(data?.getDuplicateImportedFamilies)
                setShowDuplicateImportDialouge(true)
                setOverrideDialogType('Import')
            } else if (
                filesData?.fileInfo?.filter((item) => !item.imported)
                    ?.length === 0
            ) {
                showGlobalSnackbar({
                    variables: {
                        message: 'All files are already imported',
                        variant: 'error',
                        id: 'ProjectImportPage_UploadFileError',
                    },
                })
            } else {
                const filesWithoutAssociation = filesData?.fileInfo?.filter(
                    (item) =>
                        (!item.associations ||
                            item.associations.length === 0) &&
                        item?.productTypeInfo?.filter(
                            (itemPT) =>
                                !itemPT.associations ||
                                itemPT.associations.length === 0
                        )?.length === Number(item?.productTypeCount) &&
                        item.imported === false
                )
                if (filesWithoutAssociation?.length !== 0) {
                    setShowEmptyAssociationDialog(true)
                } else {
                    setOverrideDialogType('Import')
                    setShowDuplicateImportDialouge(false)
                    setShowOverrideDialog(
                        filesData?.fileInfo?.filter(
                            (item) => item.imported === false
                        )?.length !== 0
                            ? true
                            : false
                    )
                }
            }
        },
    })

    const [
        deletePublishedImportedFamily,
        { loading: deletePublishedImportedFamilyLoading },
    ] = useMutation<
        {
            deletePublishedImportedProductFamily: DeletePublishedProductFamilyInfoResponse
        },
        { input: DeletePublishedProductFamilyInfoInput }
    >(DeletePublishedImportedProductFamilyMutation, {
        onCompleted: () => {
            setShowDuplicateImportDialouge(false)

            showGlobalSnackbar({
                variables: {
                    message: 'Deleted Successfully',
                    variant: 'success',
                    id: `deleteImportedFamily_Success`,
                },
            })
        },
        onError: (error) => {
            showGlobalSnackbar({
                variables: {
                    message: error.message,
                    variant: 'error',
                    id: `deleteImportedFamily_Error`,
                },
            })
        },
    })

    const handleDeleteElement = React.useCallback(() => {
        // in case of duplicate family , import will executed instead of show replacing associations
        handleStartExecution(undefined, true, false)
        setShowDuplicateImportDialouge(false)
        const publishedFileExit = isPublishiedFile?.filter(
            (item) => item?.status === 'Published'
        )
        const selectedFile = filesData?.fileInfo?.filter(
            (item) => item?.title === removeFileData?.values?.expander
        )?.[0]
        if (publishedFileExit && publishedFileExit.length) {
            deletePublishedImportedFamily({
                variables: {
                    input: {
                        projectId: currentProjectId!,
                        elementId: selectedFile?.familyGuid!,
                    },
                },
            })
        }
    }, [
        currentProjectId,
        showDuplicateImportDialoge,
        showOverrideDialog,
        isPublishiedFile,
    ])

    /* ----------------------------------------------------------------------------------------------------------------- */

    const startImport = React.useCallback(() => {
        if (isBPImport) {
            //Remove this condition when version criteria is production ready
            if (isVersionCriteriaEnabled) {
                // get the list of families that are not yet imported and send it to the server to get the list of duplicate imported families
                const importedFamilies =
                    filesData?.fileInfo
                        ?.filter((x) => !x.imported)
                        .map((value) => {
                            return {
                                familyNumber: value.familyId,
                                familyName: value?.title?.replace(
                                    /^[^\s]*\s+/g,
                                    ''
                                ),
                            } as DuplicateImportedFamilyInput
                        }) ?? []
                checkForDuplicateOfficeMasterImportedFamilies({
                    variables: {
                        input: {
                            projectId: currentProjectId,
                            importedFamilies: importedFamilies,
                        },
                    },
                })
            } else {
                //Remove this block when version criteria is production ready
                const uploadedFile = filesData?.fileInfo?.filter(
                    (val) => val.imported === false
                )
                checkForDuplicateImportedFamilies({
                    variables: {
                        input: {
                            projectId: currentProjectId,
                            importedFamilies: uploadedFile?.map(
                                (value, index) => {
                                    return {
                                        familyNumber: value.familyId,
                                        familyName: value?.title?.replace(
                                            /^[^\s]*\s+/g,
                                            ''
                                        ),
                                    }
                                }
                            ),
                        },
                    },
                })
            }
        } else if (
            filesData?.fileInfo?.filter((item) => !item.imported)?.length === 0
        ) {
            showGlobalSnackbar({
                variables: {
                    message: 'All files are already imported',
                    variant: 'error',
                    id: 'ProjectImportPage_UploadFileError',
                },
            })
        } else {
            const filesWithoutAssociation = filesData?.fileInfo?.filter(
                (item) =>
                    (!item.associations || item.associations.length === 0) &&
                    item?.productTypeInfo?.filter(
                        (itemPT) =>
                            !itemPT.associations ||
                            itemPT.associations.length === 0
                    )?.length === Number(item?.productTypeCount) &&
                    item.imported === false
            )
            if (filesWithoutAssociation?.length !== 0) {
                setShowEmptyAssociationDialog(true)
            } else {
                setOverrideDialogType('Import')
                setShowDuplicateImportDialouge(false)
                setShowOverrideDialog(
                    filesData?.fileInfo?.filter(
                        (item) => item.imported === false
                    )?.length !== 0
                        ? true
                        : false
                )
            }
        }
    }, [filesData, showGlobalSnackbar])

    const onCheckDuplicateOfficeMasterImportedFamilies = React.useCallback(
        (duplicateFamilyData: ProjectElementNode[]) => {
            if (duplicateFamilyData && duplicateFamilyData?.length !== 0) {
                setShowDuplicateImportDialouge(true)
                setOverrideDialogType('Import')
            } else if (
                filesData?.fileInfo?.filter((item) => !item.imported)
                    ?.length === 0
            ) {
                showGlobalSnackbar({
                    variables: {
                        message: 'All files are already imported',
                        variant: 'error',
                        id: 'ProjectImportPage_UploadFileError',
                    },
                })
            } else {
                const filesWithoutAssociation = filesData?.fileInfo?.filter(
                    (item) =>
                        (!item.associations ||
                            item.associations.length === 0) &&
                        item?.productTypeInfo?.filter(
                            (itemPT) =>
                                !itemPT.associations ||
                                itemPT.associations.length === 0
                        )?.length === Number(item?.productTypeCount) &&
                        item.imported === false
                )
                if (filesWithoutAssociation?.length !== 0) {
                    setShowEmptyAssociationDialog(true)
                } else {
                    setOverrideDialogType('Import')
                    setShowDuplicateImportDialouge(false)
                    setShowOverrideDialog(
                        filesData?.fileInfo?.filter(
                            (item) => item.imported === false
                        )?.length !== 0
                            ? true
                            : false
                    )
                }
            }
        },
        [filesData]
    )

    // contains the list of duplicate families' versions for user selection
    const [
        duplicateOfficeMasterImportFamilies,
        setDuplicateOfficeMasterImportFamilies,
    ] = React.useState<ProjectElementNode[]>([])

    const [checkForDuplicateOfficeMasterImportedFamilies] = useLazyQuery<
        DuplicateOfficeMasterImportedFamiliesResponse,
        GetDuplicateImportedFamiliesInput
    >(GetDuplicateOfficeMasterImportedFamilies, {
        fetchPolicy: 'no-cache',
        displayName: 'GetDuplicateOfficeMasterImportedFamilies',
        onCompleted: (data: DuplicateOfficeMasterImportedFamiliesResponse) => {
            const result =
                data?.getDuplicateOfficeMasterImportedFamilies
                    .projectElementNodes ?? []

            const familyBuckets = result.filter(
                (family) =>
                    family.elementType ===
                    OMElementLibraryElementType.PRODUCTFAMILYBUCKET
            )

            // update some family data to associate them correctly with their family bucket
            result.forEach((family) => {
                if (
                    (family.elementType as ProjectElementType) ===
                    ProjectElementType.PRODUCTFAMILY
                ) {
                    family.parentNodeId =
                        familyBuckets.find(
                            (bucket) => bucket.text === family.text
                        )?.id ?? family.parentNodeId
                    family.treePath = `${family.treePath}|${family.iteration?.name}`
                    family.hasChildren = false
                }
            })

            setDuplicateOfficeMasterImportFamilies(result)
            onCheckDuplicateOfficeMasterImportedFamilies(result)
        },
    })

    const [
        matchAssemblyAssociationsWithExistingVersions,
        { data: matchAssemblyAssociationsData },
    ] = useLazyQuery<
        CheckAssemblyAssociationsResponse,
        CheckAssemblyAssociationsInput
    >(MatchAssemblyAssociationsWithExistingVersionsQuery, {
        fetchPolicy: 'no-cache',
        displayName: 'GetDuplicateOfficeMasterImportedFamilies',
        onCompleted: (data) => {
            const hasNotMatchingAssemblyTreePaths = data?.matchAssemblyAssociationsWithExistingVersions?.results?.some(
                (result) =>
                    !!result?.notMatchingAssemblyTreePaths &&
                    !!result?.notMatchingAssemblyTreePaths.length &&
                    !isReactiveContentTeamFromStudioPage()?.value &&
                    isBPImport
            )
            setShowAssociationWarningDialog(!!hasNotMatchingAssemblyTreePaths)

            // Determine if we should execute import
            if (!hasNotMatchingAssemblyTreePaths) {
                setShouldExecuteImport(true)
            }
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ProjectImportPage_VCMatchAssociationError',
                },
            })
        },
    })
    /**
     * Handles the initiation of an import execution process.
     * If version criteria is enabled, displays an override dialog;
     * otherwise, starts the execution directly.
     *
     * @param isImportOverwrite - Indicates if the import should overwrite existing data.
     */
    const handleStartImportExecution = React.useCallback(
        (isImportOverwrite: boolean) => {
            if (isVersionCriteriaEnabled) {
                setShowDuplicateImportDialouge(false)
                setIsImportOverwriteSelected(isImportOverwrite)
                setShowOverrideDialog(true)
            } else {
                handleStartExecution(undefined, true, false, isImportOverwrite)
            }
        },
        [handleStartExecution]
    )

    const [checkForDuplicateAssociation] = useLazyQuery<
        DuplicateTreePathResponse
    >(CheckForDuplicateAssociationQuery, {
        fetchPolicy: 'no-cache',
        displayName: 'GetDuplicateFileResponse',
        onCompleted: (data) => {
            if (data.hasProjectProductFamily) {
                const duplicatePaths: DuplicatePath[] = data.hasProjectProductFamily.filter(
                    (item) => item.familyExist
                )
                if (duplicatePaths.length !== 0) {
                    setOverRiddenPaths(
                        duplicatePaths.map((item) => {
                            return (
                                selectedFile?.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                )! +
                                ' ' +
                                item.familyName!
                            )
                        })
                    )
                    const localSelectAssociations = selectedFilesAssociations?.map(
                        (item) => {
                            return {
                                ...item,
                                treePath: item?.treePath,
                                isForReplacement: item?.isForReplacement
                                    ? true
                                    : item?.hasSubItems
                                    ? data?.hasProjectProductFamily?.some(
                                          (itemInner) =>
                                              itemInner?.familyExist &&
                                              item?.treePath?.split(
                                                  `||${item?.familyId}`
                                              )?.[0] === itemInner?.treePath
                                      )
                                    : false,
                                assemblyName: item?.treePath?.split(
                                    /\|(?=[^\|]+$)/
                                )?.[1],
                            }
                        }
                    )
                    setSelectedFileForAssociation(localSelectAssociations)

                    setOverrideDialogType('Association')
                    {
                        !isBPImport && setShowOverrideDialog(true)
                    }
                } else {
                    handleConfirmAssociation()
                }
            }
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ProjectImportPage_SaveAssociationsError',
                },
            })
            setShowAssociationDialog(false)
            setSelectedElementIdentifier?.(undefined)
            setCategoryElementStates?.({})
            setShowOverrideDialog(false)
            setShowDuplicateImportDialouge(false)
        },
    })
    const [getImportedFiles, { loading: getFilesLoading }] = useLazyQuery<
        GetImoprtedFilesResponse
    >(
        GetImportFilesQuery,

        {
            fetchPolicy: 'network-only',
            nextFetchPolicy: 'cache-first',
            onCompleted: (data) => {
                if (data) {
                    const importedFilesData = {
                        ...filesData,
                        fileInfo:
                            shortedImportTableData(
                                data?.projectImportedProductFamilyDetails
                                    ?.filter((item) => item.title !== null)
                                    ?.map((item) => {
                                        return {
                                            ...item,
                                            imported: true,
                                            productTypeInfo: item?.productTypeInfo?.map(
                                                (itemPT) => {
                                                    return {
                                                        ...itemPT,
                                                        associations: item?.productFamilyAndTypeAssociation?.productTypeAssociations
                                                            ?.filter(
                                                                (
                                                                    itemAssociation
                                                                ) =>
                                                                    itemAssociation?.productTypeName ===
                                                                    itemPT?.name
                                                            )?.[0]
                                                            ?.associatedTreePath?.map(
                                                                (
                                                                    itemTreePath
                                                                ) => {
                                                                    return {
                                                                        treePath: itemTreePath,
                                                                        familyName:
                                                                            item?.title,
                                                                        productTypeName: [
                                                                            itemPT?.name!,
                                                                        ],
                                                                    }
                                                                }
                                                            ),
                                                    }
                                                }
                                            ),
                                            parentAssemblyTreePaths:
                                                item?.parentAssemblyTreePaths,
                                            associations: item?.productFamilyAndTypeAssociation?.productFamilyAssociations?.map(
                                                (itemInner) => {
                                                    return {
                                                        treePath:
                                                            itemInner?.productFamilyTreePath,
                                                        familyName: item?.title,
                                                        elementId:
                                                            itemInner?.parentElementId,
                                                        hasSubItems:
                                                            itemInner?.hasSubItems ??
                                                            false,
                                                        productTypeName: undefined,
                                                    }
                                                }
                                            ),
                                        }
                                    })
                            ) ?? [],
                    }
                    setFilesData(importedFilesData)
                    if (data?.projectImportedProductFamilyDetails?.[0]) {
                        if (
                            data?.projectImportedProductFamilyDetails?.filter(
                                (item) =>
                                    item?.fileKey === selectedFile?.fileKey
                            )?.length === 0
                        ) {
                            setSelectedFile(
                                data?.projectImportedProductFamilyDetails?.[0]
                            )
                        } else {
                            const newSelectedFile = importedFilesData?.fileInfo?.filter(
                                (item) =>
                                    item?.fileKey === selectedFile?.fileKey
                            )?.[0]
                            setSelectedFile(newSelectedFile)
                            setSelectedFileForPreview(newSelectedFile)
                        }
                        data?.projectImportedProductFamilyDetails?.filter(
                            (item) => item?.fileKey === selectedFile?.fileKey
                        )?.length === 0 &&
                            setSelectedFile(
                                data?.projectImportedProductFamilyDetails?.[0]
                            )
                    }
                    setAllUploadedFamilies(
                        data?.projectImportedProductFamilyDetails?.map(
                            (item) => {
                                return {
                                    familyId: item.familyId?.replaceAll(
                                        /['"]+/g,
                                        ''
                                    ),
                                    fileKey: item.fileKey,
                                    imported: true,
                                }
                            }
                        )
                    )
                }
            },
            onError: (err) => {
                showGlobalSnackbar({
                    variables: {
                        message: err.message,
                        variant: 'error',
                        id: 'ProjectImportPage_GetImportFilesError',
                    },
                })
            },
        }
    )
    const handleContinueImport = (_: React.MouseEvent<Element, MouseEvent>) => {
        const duplicateFamilies = duplicateFileResponse?.duplicateFamilies?.filter(
            (item, index) => {
                return (
                    duplicateFileResponse?.duplicateFamilies
                        ?.map((mapItem) =>
                            mapItem['familyId']?.replaceAll(/['"]+/g, '')
                        )
                        .indexOf(item['familyId']?.replaceAll(/['"]+/g, '')) ===
                    index
                )
            }
        )
        const filesProgressDataWithFamilyId = filesProgressData?.map((item) => {
            return {
                ...item,
                familyId: duplicateFileResponse?.userImportedFamilies
                    ?.filter((itemInner) => itemInner.fileKey === item.key)?.[0]
                    ?.familyId?.replaceAll(/['"]+/g, ''),
            }
        })
        const uniqueFamilies =
            duplicateFileResponse?.duplicateFamilies?.length === 0
                ? duplicateFileResponse?.userImportedFamilies
                : duplicateFileResponse?.userImportedFamilies?.filter((item) =>
                      duplicateFileResponse?.duplicateFamilies?.some(
                          (itemDuplicate) =>
                              itemDuplicate?.familyId?.replaceAll(
                                  /['"]+/g,
                                  ''
                              ) !== item.familyId?.replaceAll(/['"]+/g, '')
                      )
                  )
        const duplicateFilesFromPreviousUploads =
            allUploadedFamilies?.filter((item) => !item?.imported)?.length == 0
                ? []
                : [
                      ...duplicateFamilies!,
                      ...uniqueFamilies!,
                  ]?.filter((itemAll) =>
                      allUploadedFamilies?.some(
                          (item) =>
                              item?.familyId?.replaceAll(/['"]+/g, '') ===
                                  itemAll?.familyId?.replaceAll(/['"]+/g, '') &&
                              !item?.imported
                      )
                  )

        if (
            duplicateFilesFromPreviousUploads.length === 0 &&
            duplicateFamilies?.length !== 0
        ) {
            const updatedProgressFiles = filesProgressDataWithFamilyId?.filter(
                (item) =>
                    !duplicateFamilies?.some(
                        (itemInner) => item.key === itemInner.fileKey
                    )
            )
            setFilesProgressData(updatedProgressFiles)

            if (filesData) {
                setAllUploadedFamilies([
                    ...filesData?.fileInfo?.map((item) => {
                        return {
                            familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                            fileKey: item.fileKey,
                            imported: false,
                        }
                    })!,
                    ...updatedProgressFiles?.map((item) => {
                        return {
                            familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                            fileKey: item.key,
                        }
                    })!,
                ])
            } else {
                setAllUploadedFamilies([
                    ...updatedProgressFiles?.map((item) => {
                        return {
                            familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                            fileKey: item.key,
                            imported: false,
                        }
                    })!,
                ])
            }

            setItemToImportFile(
                uploadedPickerData?.filesUploaded?.filter((item) =>
                    updatedProgressFiles?.some(
                        (itemInner) => itemInner.key === item.key
                    )
                )?.[0]
            )
            setUploadedPickerData({
                filesFailed: uploadedPickerData?.filesFailed,
                filesUploaded: uploadedPickerData?.filesUploaded?.filter(
                    (item) =>
                        updatedProgressFiles?.some(
                            (itemInner) => itemInner.key === item.key
                        )
                ),
            })
        } else if (
            duplicateFilesFromPreviousUploads.length !== 0 &&
            duplicateFamilies?.length === 0
        ) {
            setFilesData({
                ...filesData,
                fileInfo: shortedImportTableData(
                    filesData?.fileInfo
                        ?.filter(
                            (item) =>
                                !duplicateFilesFromPreviousUploads?.some(
                                    (itemInner) =>
                                        itemInner.familyId?.replaceAll(
                                            /['"]+/g,
                                            ''
                                        ) ===
                                            item.familyId?.replaceAll(
                                                /['"]+/g,
                                                ''
                                            ) && !item?.imported
                                )
                        )
                        ?.map((item) => {
                            return {
                                ...item,
                                imported: item.imported ?? false,
                                associations: addWorkResultItemsOnFamilies(
                                    item,
                                    workresultNodes?.getProjectElementNodes
                                        ?.projectElementNodes!
                                ),
                            }
                        })!
                ),
            })
            setAllUploadedFamilies([
                ...filesData?.fileInfo
                    ?.filter(
                        (item) =>
                            !duplicateFilesFromPreviousUploads?.some(
                                (itemInner) =>
                                    itemInner.familyId?.replaceAll(
                                        /['"]+/g,
                                        ''
                                    ) ===
                                        item.familyId?.replaceAll(
                                            /['"]+/g,
                                            ''
                                        ) && !item?.imported
                            )
                    )
                    ?.map((item) => {
                        return {
                            familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                            fileKey: item.fileKey,

                            import: item?.imported,
                        }
                    })!,
                ...filesProgressData?.map((item) => {
                    return {
                        familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                        fileKey: item.key,
                    }
                })!,
            ])

            setItemToImportFile(
                uploadedPickerData?.filesUploaded?.filter((item) =>
                    filesProgressData?.some(
                        (itemInner) => itemInner.key === item.key
                    )
                )?.[0]
            )

            setUploadedPickerData({
                filesFailed: uploadedPickerData?.filesFailed,
                filesUploaded: uploadedPickerData?.filesUploaded?.filter(
                    (item) =>
                        filesProgressData?.some(
                            (itemInner) => itemInner.key === item.key
                        )
                ),
            })
        } else if (
            duplicateFilesFromPreviousUploads.length !== 0 &&
            duplicateFamilies?.length !== 0
        ) {
            const filesWithoutOuterInnerData = filesProgressDataWithFamilyId?.filter(
                (item) =>
                    !duplicateFamilies?.some(
                        (itemInner) => item.key === itemInner.fileKey
                    )
            )
            setFilesProgressData(filesWithoutOuterInnerData)
            setAllUploadedFamilies([
                ...filesData?.fileInfo?.map((item) => {
                    return {
                        familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                        fileKey: item.fileKey,
                    }
                })!,
                ...filesWithoutOuterInnerData?.map((item) => {
                    return {
                        familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                        fileKey: item.key,
                    }
                })!,
            ])
            setItemToImportFile(
                uploadedPickerData?.filesUploaded?.filter((item) =>
                    filesWithoutOuterInnerData?.some(
                        (itemInner) => itemInner.key === item.key
                    )
                )?.[0]
            )
            setFilesData({
                ...filesData,
                fileInfo: shortedImportTableData(
                    filesData?.fileInfo
                        ?.filter(
                            (item) =>
                                !filesWithoutOuterInnerData?.some(
                                    (itemInner) =>
                                        itemInner.familyId?.replaceAll(
                                            /['"]+/g,
                                            ''
                                        ) ===
                                            item.familyId?.replaceAll(
                                                /['"]+/g,
                                                ''
                                            ) && !item?.imported
                                )
                        )
                        ?.map((item) => {
                            return {
                                ...item,
                                imported: item.imported ?? false,
                                associations: addWorkResultItemsOnFamilies(
                                    item,
                                    workresultNodes?.getProjectElementNodes
                                        ?.projectElementNodes!
                                ),
                            }
                        })!
                ),
            })
            setUploadedPickerData({
                filesFailed: uploadedPickerData?.filesFailed,
                filesUploaded: uploadedPickerData?.filesUploaded?.filter(
                    (item) =>
                        filesWithoutOuterInnerData?.some(
                            (itemInner) => itemInner.key === item.key
                        )
                ),
            })
        }
        setFileExtractionLoading(true)

        setShowDuplicateDialog(false)
    }
    const cancelFileUpload = React.useCallback(() => {
        setShowDuplicateDialog(false)
        setFilesProgressData([])
        setShowDuplicateDialog(false)
        setDuplicateFamilies([])
        setUploadedPickerData(undefined)
    }, [])
    const cancelSaveAssociation = React.useCallback(() => {
        setOverrideDialogType(undefined)
        setShowOverrideDialog(false)
        setOverRiddenPaths(undefined)
        setShowDuplicateImportDialouge(false)
    }, [])

    const getAssociationLists = (
        list: CheckForDuplicateFilesInAssemblyInput[],
        isProductType?: boolean,
        removedElementTreePath?: string
    ) => {
        const updatedList = list
            ?.map((item) => {
                return {
                    ...item,
                    treePath: item?.treePath,
                }
            })
            ?.filter(
                (item, index, nextItem) =>
                    nextItem.findIndex(
                        (item2) => item2?.treePath === item?.treePath
                    ) === index
            )
        if (isProductType) {
            const updatedFileData: Partial<ImportUploadFileInfo> = {
                ...selectedFile,
                productTypeInfo: selectedFile?.productTypeInfo?.map((item) => {
                    if (
                        item?.name?.toLowerCase() ===
                        selectedFile?.selectedProductTypeName?.toLowerCase()
                    ) {
                        return {
                            ...item,
                            associations:
                                updatedList?.length === 0
                                    ? undefined
                                    : updatedList,
                        }
                    } else {
                        return item
                    }
                }),
            }

            setSelectedFileForAssociation(updatedList)
        } else {
            const newUpdatedList = [
                ...new Map(
                    [
                        ...updatedList,
                        ...selectedFilesAssociations,
                    ].map((item) => [item['treePath'], item])
                ).values(),
            ]
            if (newUpdatedList?.length !== selectedFilesAssociations?.length) {
                const updateAssociations = removedElementTreePath
                    ? selectedFilesAssociations?.filter(
                          (itemRemoved) =>
                              itemRemoved?.treePath !== removedElementTreePath
                      )
                    : [...selectedFilesAssociations, ...updatedList]?.filter(
                          (item, index, nextItem) =>
                              nextItem.findIndex(
                                  (item2) => item2?.treePath === item?.treePath
                              ) === index
                      )

                setSelectedFileForAssociation(updateAssociations)
            }
        }
    }
    const hideAssociation = React.useCallback(() => {
        setShowAssociationDialog(false)
        setSelectedElementIdentifier?.(undefined)
        setCategoryElementStates?.({})
    }, [])

    const handleAssociationWarningDialog = React.useCallback(() => {
        setShouldExecuteImport(false)
        setShowAssociationWarningDialog(false)
    }, [showAssociationWarningDialog])

    const handleConfirmAssociation = (
        event?: React.MouseEvent<Element, MouseEvent>
    ) => {
        const selectedPTName = selectedFile?.selectedProductTypeName
        const updatedFilesData = selectedPTName
            ? {
                  ...selectedFile,
                  productTypeInfo: selectedFile?.productTypeInfo?.map(
                      (item) => {
                          if (item.name === selectedPTName) {
                              return {
                                  ...item,
                                  associations: selectedFilesAssociations,
                              }
                          } else {
                              return item
                          }
                      }
                  ),
              }
            : {
                  ...selectedFile,
                  associations: selectedFilesAssociations,
              }
        setOverrideDialogType(undefined)
        setSelectedFile(updatedFilesData)
        setFilesData({
            ...filesData,
            fileInfo: shortedImportTableData(
                [
                    ...filesData?.fileInfo?.filter(
                        (item) => item.fileKey !== selectedFile?.fileKey
                    )!,
                    updatedFilesData,
                ]?.map((item) => {
                    return { ...item, imported: item?.imported ?? false }
                })
            ),
        })
        setOverRiddenPaths(undefined)
        setShowAssociationDialog(false)
        setSelectedElementIdentifier?.(undefined)
        setCategoryElementStates?.({})
        setShowOverrideDialog(false)
        if (selectedFile?.imported) {
            handleStartExecution(event, true, true)
        }
    }
    const handleResetElements = (value: boolean) => {
        setRefreshElementPanel(value)
    }
    const handleImportWithPublish = (
        event: React.MouseEvent<Element, MouseEvent>
    ) => {
        setImportedFilesToBePublished(true)
        handleStartExecution(event, true, false)
    }

    const getUpdatedTreePaths = React.useCallback(
        (currentTreePaths) =>
            currentTreePaths?.map(
                (itemPath: string) =>
                    itemPath?.split(
                        `||${selectedFile?.familyId?.replaceAll(/['"]+/g, '')}`
                    )?.[0]
            ),
        [selectedFile]
    )

    const handleSaveAssociation = (
        _: React.MouseEvent<Element, MouseEvent>
    ) => {
        const previousAssociations = filesData?.fileInfo
            ?.filter((item) => item?.fileKey === selectedFile?.fileKey)?.[0]
            ?.associations?.sort()

        const previousData = selectedFile?.selectedProductTypeName
            ? selectedFile?.productTypeInfo?.filter(
                  (item) =>
                      item?.name?.toLowerCase() ===
                      selectedFile?.selectedProductTypeName?.toLowerCase()
              )?.[0]?.associations
            : previousAssociations
        const uniqueData = previousData?.filter?.(
            (itemUnique) =>
                !selectedFilesAssociations?.some(
                    (itemInner) =>
                        itemInner?.treePath === itemUnique?.treePath &&
                        itemInner?.familyName === itemUnique?.familyName &&
                        itemInner?.productTypeName?.[0] ===
                            itemUnique?.productTypeName?.[0]
                )
        )
        if (
            selectedFile?.imported &&
            ((selectedFilesAssociations?.length ===
                (previousAssociations ?? [])?.length &&
                uniqueData?.length === 0) ||
                isBPImport)
        ) {
            hideAssociation()
        } else {
            if (
                selectedFilesAssociations &&
                selectedFilesAssociations.length === 0
            ) {
                if (selectedFile?.selectedProductTypeName) {
                    const updatedFilesData = {
                        ...selectedFile,
                        productTypeInfo: selectedFile?.productTypeInfo?.map(
                            (item) => {
                                if (
                                    item.name?.toLowerCase() ===
                                    selectedFile?.selectedProductTypeName?.toLowerCase()
                                ) {
                                    return { ...item, associations: undefined }
                                } else {
                                    return item
                                }
                            }
                        ),
                    }
                    if (selectedFile?.imported) {
                        handleConfirmAssociation()
                    } else {
                        setSelectedFile(updatedFilesData)
                        setFilesData({
                            ...filesData,
                            fileInfo: shortedImportTableData(
                                [
                                    ...filesData?.fileInfo?.filter(
                                        (item) =>
                                            item.fileKey !==
                                            selectedFile?.fileKey
                                    )!,
                                    updatedFilesData,
                                ]?.map((item) => {
                                    return {
                                        ...item,
                                        imported: item?.imported ?? false,
                                    }
                                })!
                            ),
                        })
                    }
                } else {
                    const updatedFilesData = {
                        ...selectedFile,
                        associations: undefined,
                    }

                    setSelectedFile(updatedFilesData)
                    setFilesData({
                        ...filesData,
                        fileInfo: shortedImportTableData(
                            [
                                ...filesData?.fileInfo?.filter(
                                    (item) =>
                                        item.fileKey !== selectedFile?.fileKey
                                )!,
                                updatedFilesData,
                            ]?.map((item) => {
                                return {
                                    ...item,
                                    imported: item?.imported ?? false,
                                }
                            })!
                        ),
                    })
                }

                setShowAssociationDialog(false)
                setSelectedElementIdentifier?.(undefined)
                setCategoryElementStates?.({})
                setShowOverrideDialog(false)
            } else {
                const treePaths: string[] = []
                const allTreePaths: string[] = []

                selectedFilesAssociations.forEach((item) => {
                    if (item.hasSubItems && !item?.emptyWithoutAssociations) {
                        treePaths.push(item.treePath!)
                    }
                    allTreePaths.push(item.treePath!)
                })

                const familyId = selectedFile?.familyId?.replace(/['"]+/g, '')
                setAssemblyAssociation({
                    ...assemblyAssociation!,
                    [familyId!]: {
                        familyNumber: familyId,
                        associatedAssemblyTreePaths: getUpdatedTreePaths(
                            allTreePaths
                        ),
                    } as assemblyAssociationInputs,
                })

                treePaths.length !== 0
                    ? checkForDuplicateAssociation({
                          variables: {
                              input: {
                                  treePaths: getUpdatedTreePaths(treePaths),
                                  familyId,
                                  projectId: currentProjectId,
                              },
                          },
                      })
                    : handleConfirmAssociation()
            }
        }
    }
    const handleClickSetAssociationButton = (
        data: Partial<ImportUploadFileInfo>,
        productTypeName?: string
    ) => {
        setOverrideDialogType('Association')
        if (productTypeName && productTypeName.length !== 0) {
            setSelectedFile({
                ...data,
                selectedProductTypeName: productTypeName,
            })
            setSelectedFileForAssociation(
                data?.productTypeInfo
                    ?.filter((item) => item.name === productTypeName)?.[0]
                    ?.associations?.map((item) => {
                        return {
                            ...item,

                            treePath:
                                item?.treePath?.split(
                                    `||${selectedFile?.familyId?.replaceAll(
                                        /['"]+/g,
                                        ''
                                    )}`
                                )?.[0] ?? item?.treePath,
                        }
                    }) ?? []
            )
        } else {
            setSelectedFile({
                ...data,
                associations: data?.associations?.map((item) => {
                    return {
                        ...item,
                        isForReplacement: data?.parentAssemblyTreePaths?.some(
                            (itemTree) => itemTree?.includes(item?.treePath!)
                        )!,
                    }
                })!,
                selectedProductTypeName: undefined,
            })
            setSelectedFileForAssociation(
                data?.associations?.map((item) => {
                    return {
                        ...item,
                        isForReplacement: data?.parentAssemblyTreePaths?.some(
                            (itemTree) => itemTree?.includes(item?.treePath!)
                        )!,
                    }
                })!
            )
        }
        setShowAssociationDialog(true)
    }
    const openAssociationDialog = React.useCallback(
        (_: React.MouseEvent<Element, MouseEvent>) => {
            handleClickSetAssociationButton(
                filesData?.fileInfo?.filter(
                    (item) =>
                        (!item.associations ||
                            item?.associations?.length == 0) &&
                        !item.imported
                )?.[0]!
            )
            setShowEmptyAssociationDialog(false)
        },
        [filesData]
    )
    const handleCloseEmptyAssociationDialog = () => {
        setShowEmptyAssociationDialog(false)
    }

    const [getDuplicateFiles] = useLazyQuery<{
        getImportDuplicateFamily: Partial<CheckDuplicateFilesForImport> | null
    }>(CheckForDuplicateFileQuery, {
        onCompleted: (data) => {
            data?.getImportDuplicateFamily &&
                handleChangeDuplicateFileFileStatus(
                    data?.getImportDuplicateFamily
                )
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ProjectImportPage_UploadFileError',
                },
            })
        },
    })
    const [discardImport, { loading: discardFileLoading }] = useMutation<
        { discardFileForImport: Partial<DiscardFileResponse> },
        { input: Partial<DiscardFileInput> }
    >(ImportDiscardFileMutation, {
        onCompleted: (data) => {
            if (!data?.discardFileForImport?.errorMessage) {
                const updatedFileInfo = filesData?.fileInfo?.filter(
                    (item) => item?.fileKey !== data?.discardFileForImport?.key
                )

                handleDeletedFiles(updatedFileInfo!)
            } else {
                showGlobalSnackbar({
                    variables: {
                        message: data?.discardFileForImport?.errorMessage ?? '',
                        variant: 'error',
                        id: 'ProjectImportPage_RemoveFileError',
                    },
                })
                setRemoveFileData(undefined)
            }
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ProjectImportPage_DiscardFileError',
                },
            })
            setRemoveFileData(undefined)
        },
    })
    const handleDeletedFiles = React.useCallback(
        (updatedFileInfo: Partial<ImportUploadFileInfo>[]) => {
            if (updatedFileInfo && updatedFileInfo.length !== 0) {
                setFilesData({
                    ...filesData,
                    fileInfo: shortedImportTableData(
                        updatedFileInfo.map((item) => {
                            return {
                                ...item,
                                familyId: item?.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                ),
                            }
                        })!
                    ),
                })
                setAllUploadedFamilies(
                    updatedFileInfo.map((item) => {
                        return {
                            familyId: item?.familyId?.replaceAll(/['"]+/g, ''),
                            fileKey: item.fileKey,
                        }
                    })
                )
                setRemoveFileData(undefined)
            } else {
                setPreviewInstanceId(null)
                setSelectedFileForPreview(undefined)
                setSelectedFile(undefined)
                handleSelectFileForPreview()
                setFilesData(undefined)
                setAllUploadedFamilies(undefined)
                setImportPreviewData(undefined)
                setRemoveFileData(undefined)
            }
        },
        [filesData]
    )
    const [discardImportBP, { loading: discardFileLoadingBP }] = useMutation<
        { deleteImportedFamily: boolean },
        { input: Partial<DiscardFileInput> }
    >(BPImportDeleteImportedFamilyMutation, {
        onCompleted: (data) => {
            if (data?.deleteImportedFamily) {
                const updatedFileInfo = filesData?.fileInfo?.filter(
                    (item) => item?.title !== removeFileData?.values?.expander
                )

                handleDeletedFiles(updatedFileInfo!)
            }
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: err.message,
                    variant: 'error',
                    id: 'ProjectImportPage_UploadFileError',
                },
            })
            setRemoveFileData(undefined)
        },
    })

    const handlePickerDoneTransfer = (value: PickerResponse) => {
        const files = value?.filesUploaded?.map((itemFile, index) => {
            return {
                key: itemFile.key!,
                fileName: itemFile.filename!,
            }
        })
        setDuplicateFilesLoading(true)

        getDuplicateFiles({
            variables: {
                input: {
                    userFiles: files,
                    projectId: currentProjectId!,
                    firmId: firmId!,
                },
            },
        })
        setFilesProgressData(
            files.map((itemFile, index) => {
                return {
                    key: itemFile.key!,
                    fileName: itemFile.fileName!,
                    processing: index === 0,
                }
            })
        )

        setUploadedPickerData(value)
    }

    /**
     * This is a workaround for the filestack
     * "onOpen" delay. It starts a poll for the presence of
     * the filestack picker modal in the DOM, and sets
     * the filestackLoading state to false once the
     * element is found.
     */
    const checkPickerUi = () => {
        const hasPickerUi =
            document.getElementsByClassName('fsp-modal').length >= 1
        if (hasPickerUi) {
            setFilestackLoading(false)
        } else {
            setTimeout(() => checkPickerUi(), 500)
        }
    }

    const handleFilestackLoading = React.useCallback(
        (isLoading: boolean | null) => {
            if (isLoading === false) {
                // Cover the "gap" by starting a poll
                // for the picker modal element in the DOM.
                checkPickerUi()
            } else {
                setFilestackLoading(true)
            }
        },
        [checkPickerUi, setFilestackLoading]
    )

    const handleShowIssueDialog = React.useCallback(
        (fileIndex: number, type: WarningDialogType) => {
            const selectedFile = filesData?.fileInfo?.[fileIndex]

            setSelectedFile({
                ...selectedFile,
            })
            setWarningDialogType(type)
            setShowWarningDialog(true)
        },
        [filesData, selectedFile]
    )

    const handleIssueDialogDisplay = React.useCallback(() => {
        setWarningDialogType(undefined)
        setShowWarningDialog((past) => !past)
    }, [showWarningDialog, setShowWarningDialog])
    const handleExpandRow = React.useCallback(
        (
            rowId: string,
            value: boolean,
            event:
                | React.MouseEvent<SVGSVGElement>
                | React.KeyboardEvent<SVGSVGElement>
        ) => {
            event?.stopPropagation()
            if (filesData && filesData.fileInfo) {
                const files = filesData.fileInfo.map((item, index) => {
                    if (index === Number(rowId)) {
                        return { ...item, expanded: !value }
                    } else return item
                })
                setFilesData({
                    ...filesData,
                    fileInfo: shortedImportTableData(files),
                })
            }
        },
        [filesData]
    )
    const handleSelectFileForPreview = React.useCallback(
        (fileKey?: string, selectedProduct?: string) => {
            setSelectedTab(0)
            if (fileKey === undefined) {
                setImportPreviewData(undefined)
                setSelectedFileForPreview(undefined)
                return
            } else if (productTypePreviewLoading) return
            const selectedTableRow = filesData?.fileInfo?.filter(
                (item) => item?.fileKey === fileKey
            )?.[0]

            if (selectedProduct === undefined) {
                setSelectedProductTypeName(undefined)

                setSelectedRowType('Family')
                selectFileData(fileKey)
            } else {
                if (
                    selectedProduct === selectedProductTypeName &&
                    selectedTableRow?.fileKey === fileKey
                )
                    return
                setSelectedRowType('ProductType')
                setSelectedProductTypeName(selectedProduct)
                selectFileData(fileKey, selectedProduct)
            }
        },
        [importPreviewData, filesData, selectedProductTypeName]
    )
    const handleCloseImportDialog = React.useCallback(() => {
        setIsImportCompleted(true)

        setSelectedElementIdentifier?.(undefined)
        setCategoryElementStates?.({})
        handleResetElements(true)
        getImportedFiles({
            variables: {
                projectId: currentProjectId ?? contentTeamProjectId,
            },
        })
        setAssemblyStates?.({})
        setFamiliesToAdd([])
        setFamiliesToReplace([])
    }, [
        setAssemblyStates,
        setSelectedElementIdentifier,
        currentProjectId,
        contentTeamProjectId,
    ])
    const handleChangeExecuteStatus = React.useCallback(
        (files?: Partial<ExecuteImportData>, publishData?: PublishResult) => {
            if (files?.errorMessage) {
                showGlobalSnackbar({
                    variables: {
                        message: files?.errorMessage,
                        variant: 'error',
                        id: 'ProjectImportPage_DataError',
                    },
                })
            }
            if (importedFilesToBePublished && !publishData) {
                const importedFilesToBePublished =
                    files?.importResult?.map((item) => {
                        return {
                            productFamilyIdGuid:
                                item?.productFamilyIdGuid ?? '',
                            isPublished: false,
                        }
                    }) ?? []
                setFilesToPublish(importedFilesToBePublished)
                publishImportedFiles({
                    variables: {
                        id: files?.importResult?.map(
                            (item) => item?.productFamilyIdGuid
                        ),
                    },
                }).then((response) => {
                    response?.data?.publishProductFamily?.instanceId &&
                        setPublishInstanceId(
                            response?.data?.publishProductFamily?.instanceId
                        )
                })
            } else {
                handleCloseImportDialog()
            }
        },
        [
            currentProjectId,
            setSelectedElementIdentifier,
            setCategoryElementStates,
            contentTeamProjectId,
            setAssemblyStates,
            importedFilesToBePublished,
        ]
    )
    const handleChangeFileStatus = React.useCallback(
        (files?: Partial<UploadFilesForImport>, instanceId?: string) => {
            const filesToUpload = uploadedPickerData?.filesUploaded
            const newFiles: Partial<ImportUploadFileInfo>[] = filesData
                ? filesData?.fileInfo?.concat(files?.fileInfo ?? []) ?? []
                : files?.fileInfo!
            if ((files && files?.status === 'ERROR') || !files) {
                showGlobalSnackbar({
                    variables: {
                        message:
                            files?.errorMessage ??
                            `There was a problem in uploading file`,
                        variant: 'error',
                        id: 'ProjectImportPage_DataError',
                    },
                })
                setFilesProgressData(
                    filesProgressData
                        ?.filter(
                            (item) => item.key === files?.fileInfo?.[0]?.fileKey
                        )
                        ?.map((item, index) => {
                            return {
                                ...item,
                                processing: false,
                            }
                        })
                )
            }
            if (filesData) {
                setFilesData({
                    ...filesData,
                    instanceId: files?.instanceId,
                    fileInfo: shortedImportTableData(
                        newFiles.map((item) => {
                            const workresultAssociations = addWorkResultItemsOnFamilies(
                                item,
                                workresultNodes?.getProjectElementNodes
                                    ?.projectElementNodes!
                            ).filter(
                                (element) =>
                                    !item?.parentAssemblyTreePaths?.includes(
                                        element?.treePath!
                                    )
                            )
                            const parentTreePaths =
                                item?.parentAssemblyTreePaths?.map(
                                    (itemTreePath) => {
                                        return {
                                            treePath:
                                                itemTreePath +
                                                '||' +
                                                item?.familyId +
                                                '|' +
                                                item?.title?.replace(
                                                    `${item?.familyId}${' '}`,
                                                    ''
                                                ),
                                            familyName: item?.title,
                                            isForReplacement: true,
                                            assemblyName: itemTreePath.split(
                                                /\|(?=[^\|]+$)/
                                            )?.[1],
                                            elementId: '',
                                            productTypeName: undefined,
                                            familyId: item?.familyId?.replaceAll(
                                                /['"]+/g,
                                                ''
                                            ),
                                        }
                                    }
                                ) ?? []
                            const needAttentions: string =
                                filesData && filesProgressData
                                    ? String(
                                          item?.paragraphErrors?.filter(
                                              (item) =>
                                                  !item?.children?.some(
                                                      (child) =>
                                                          child.message.includes(
                                                              'Duplicate Key Renamed'
                                                          )
                                                  )
                                          )?.length
                                      ) ?? ''
                                    : filesData
                                    ? String(
                                          item?.errors
                                              ?.filter(function (
                                                  itemInner,
                                                  pos
                                              ) {
                                                  return (
                                                      item?.errors?.indexOf(
                                                          itemInner
                                                      ) == pos
                                                  )
                                              })
                                              ?.filter(
                                                  (item) =>
                                                      !item?.includes(
                                                          'Duplicate Key Renamed'
                                                      )
                                              )?.length
                                      ) ?? ''
                                    : ''
                            return {
                                ...item,
                                imported: item?.imported ?? false,
                                familyId: item?.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                ),
                                associations: [
                                    ...workresultAssociations,
                                    ...parentTreePaths,
                                ],
                                fileName:
                                    uploadedPickerData?.filesUploaded?.filter(
                                        (itemPickerData) =>
                                            itemPickerData.key === item.fileKey
                                    )?.[0]?.filename ?? item.fileName,
                                ...(!(item?.imported ?? false) && {
                                    importGuideInfo: {
                                        valueScore:
                                            item?.importGuideInfo?.valueScore ??
                                            (!(
                                                needAttentions === '' ||
                                                needAttentions === '0'
                                            )
                                                ? 0
                                                : 25),
                                        totalSteps:
                                            item?.importGuideInfo?.totalSteps ??
                                            (!(
                                                needAttentions === '' ||
                                                needAttentions === '0'
                                            )
                                                ? 0
                                                : 1),
                                        needAttentions:
                                            item?.importGuideInfo
                                                ?.needAttentions ??
                                            !(
                                                needAttentions === '' ||
                                                needAttentions === '0'
                                            ),
                                        anyOpenCautions:
                                            item?.importGuideInfo
                                                ?.anyOpenCautions ?? null,
                                        haveSetAssemblyAsso:
                                            item?.importGuideInfo
                                                ?.haveSetAssemblyAsso ?? null,
                                        haveDownldMasterSpecTemplate:
                                            item?.importGuideInfo
                                                ?.haveDownldMasterSpecTemplate ??
                                            null,
                                        haveProductTypeAppeared:
                                            item?.importGuideInfo
                                                ?.haveProductTypeAppeared ??
                                            null,
                                        haveManufacturerAppeared:
                                            item?.importGuideInfo
                                                ?.haveManufacturerAppeared ??
                                            null,
                                    },
                                }),
                            }
                        })!
                    ),
                })
                setInstanceId(null)
                setFileExtractionLoading(false)
                setAllUploadedFamilies(
                    newFiles?.map((item) => {
                        return {
                            familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                            fileKey: item.fileKey,
                            imported: false,
                        }
                    })
                )
            } else {
                setFilesData({
                    ...files,
                    fileInfo: shortedImportTableData(
                        files?.fileInfo?.map((item) => {
                            const workresultAssociations = addWorkResultItemsOnFamilies(
                                item,
                                workresultNodes?.getProjectElementNodes
                                    ?.projectElementNodes!
                            )
                            const parentTreePaths =
                                item?.parentAssemblyTreePaths
                                    ?.map((itemTreePath) => {
                                        return {
                                            treePath:
                                                itemTreePath +
                                                '||' +
                                                item?.familyId +
                                                '|' +
                                                item?.title?.replace(
                                                    `${item?.familyId}${' '}`,
                                                    ''
                                                ),
                                            familyName: item?.title,
                                            isForReplacement: true,
                                            assemblyName: itemTreePath.split(
                                                /\|(?=[^\|]+$)/
                                            )?.[1],
                                            elementId: '',
                                            productTypeName: undefined,
                                            familyId: item?.familyId?.replaceAll(
                                                /['"]+/g,
                                                ''
                                            ),
                                        }
                                    })
                                    .filter(
                                        (element) =>
                                            !workresultAssociations
                                                ?.map((item) => item?.treePath)
                                                ?.includes(element?.treePath!)
                                    ) ?? []
                            const needAttentions: string =
                                filesData && filesProgressData
                                    ? String(
                                          item?.paragraphErrors?.filter(
                                              (item) =>
                                                  !item?.children?.some(
                                                      (child) =>
                                                          child.message.includes(
                                                              'Duplicate Key Renamed'
                                                          )
                                                  )
                                          )?.length
                                      ) ?? ''
                                    : filesData
                                    ? String(
                                          item?.errors
                                              ?.filter(function (
                                                  itemInner,
                                                  pos
                                              ) {
                                                  return (
                                                      item?.errors?.indexOf(
                                                          itemInner
                                                      ) == pos
                                                  )
                                              })
                                              ?.filter(
                                                  (item) =>
                                                      !item?.includes(
                                                          'Duplicate Key Renamed'
                                                      )
                                              )?.length
                                      ) ?? ''
                                    : ''
                            return {
                                ...item,
                                imported: false,
                                familyId: item?.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                ),
                                associations: [
                                    ...workresultAssociations,
                                    ...parentTreePaths,
                                ],
                                fileName: uploadedPickerData?.filesUploaded?.filter(
                                    (itemPickerData) =>
                                        itemPickerData.key === item.fileKey
                                )?.[0]?.filename,
                                ...(!(item?.imported ?? false) && {
                                    importGuideInfo: {
                                        valueScore: !(
                                            needAttentions === '' ||
                                            needAttentions === '0'
                                        )
                                            ? 0
                                            : 25,
                                        totalSteps: !(
                                            needAttentions === '' ||
                                            needAttentions === '0'
                                        )
                                            ? 0
                                            : 1,
                                        needAttentions: !(
                                            needAttentions === '' ||
                                            needAttentions === '0'
                                        ),
                                        anyOpenCautions: null,
                                        haveSetAssemblyAsso: null,
                                        haveDownldMasterSpecTemplate: null,
                                        haveProductTypeAppeared: null,
                                        haveManufacturerAppeared: null,
                                    },
                                }),
                            }
                        })!
                    ),
                })
                setFileExtractionLoading(false)

                setAllUploadedFamilies(
                    files?.fileInfo?.map((item) => {
                        return {
                            familyId: item.familyId?.replaceAll(/['"]+/g, ''),
                            fileKey: item.fileKey,
                            imported: false,
                        }
                    })
                )
            }
            setFilesProgressData(
                filesProgressData
                    ?.filter((each) => each.instanceId !== instanceId)
                    ?.map((item) => {
                        return {
                            ...item,
                            processing: false,
                        }
                    })
            )
        },
        [showGlobalSnackbar, filesData, filesProgressData]
    )
    const handleChangeDuplicateFileFileStatus = React.useCallback(
        (files?: Partial<CheckDuplicateFilesForImport>, index?: number) => {
            setDuplicateFileResponse(files)

            const duplicateFamilies = files?.duplicateFamilies?.filter(
                (item, index) => {
                    return (
                        files?.duplicateFamilies
                            ?.map((mapItem) =>
                                mapItem['familyId']?.replaceAll(/['"]+/g, '')
                            )
                            .indexOf(
                                item['familyId']?.replaceAll(/['"]+/g, '')
                            ) === index
                    )
                }
            )
            const uniqueFamilies =
                files?.duplicateFamilies?.length === 0
                    ? files?.userImportedFamilies
                    : files?.userImportedFamilies?.filter((item) =>
                          files?.duplicateFamilies?.some(
                              (itemDuplicate) =>
                                  itemDuplicate.familyId?.replaceAll(
                                      /['"]+/g,
                                      ''
                                  ) !== item.familyId?.replaceAll(/['"]+/g, '')
                          )
                      )
            const duplicateFilesFromPreviousUploads =
                allUploadedFamilies?.filter((item) => !item?.imported)
                    ?.length === 0
                    ? []
                    : [
                          ...duplicateFamilies!,
                          ...uniqueFamilies!,
                      ]?.filter((itemAll) =>
                          allUploadedFamilies?.some(
                              (item) =>
                                  item.familyId?.replaceAll(/['"]+/g, '') ===
                                      itemAll.familyId?.replaceAll(
                                          /['"]+/g,
                                          ''
                                      ) &&
                                  !filesData?.fileInfo?.filter(
                                      (itemFile) =>
                                          itemFile?.familyId?.replaceAll(
                                              /['"]+/g,
                                              ''
                                          ) ===
                                          itemAll?.familyId?.replaceAll(
                                              /['"]+/g,
                                              ''
                                          )
                                  )?.[0]?.imported
                          )
                      )
            const allDuplicates = [
                ...duplicateFamilies!,
                ...duplicateFilesFromPreviousUploads!,
            ]
            setDuplicateFilesLoading(false)
            if (allDuplicates?.length !== 0) {
                if (
                    duplicateFilesFromPreviousUploads.length === 0 &&
                    duplicateFamilies?.length !== 0
                ) {
                    setDuplicateFileInstances(null)
                    setDuplicateFamilies(
                        duplicateFamilies
                            ?.filter((item) => !item?.imported)
                            ?.map((item) => {
                                return {
                                    key: item.fileKey,
                                    fileName: item.fileKey?.split(
                                        /_(.*)/s
                                    )?.[1],
                                    familyId: item.familyId?.replaceAll(
                                        /['"]+/g,
                                        ''
                                    ),
                                }
                            })
                            ?.filter((item, index) => {
                                return (
                                    duplicateFamilies
                                        ?.map((mapItem) =>
                                            mapItem['familyId']?.replaceAll(
                                                /['"]+/g,
                                                ''
                                            )
                                        )
                                        .indexOf(item['familyId']) === index
                                )
                            })
                    )
                    duplicateFamilies
                        ?.filter((item) => !item?.imported)
                        ?.map((item) => {
                            return {
                                key: item.fileKey,
                                fileName: item.fileKey?.split(/_(.*)/s)?.[1],
                                familyId: item.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                ),
                            }
                        })
                        ?.filter((item, index) => {
                            return (
                                duplicateFamilies
                                    ?.map((mapItem) =>
                                        mapItem['familyId']?.replaceAll(
                                            /['"]+/g,
                                            ''
                                        )
                                    )
                                    .indexOf(item['familyId']) === index
                            )
                        })?.length !== 0 && setShowDuplicateDialog(true)
                } else if (
                    duplicateFilesFromPreviousUploads.length !== 0 &&
                    duplicateFamilies?.length === 0
                ) {
                    setDuplicateFileInstances(null)
                    setDuplicateFamilies(
                        duplicateFilesFromPreviousUploads
                            ?.filter((item) => !item?.imported)
                            ?.map((item) => {
                                return {
                                    key: item.fileKey,
                                    fileName: item.fileKey?.split(
                                        /_(.*)/s
                                    )?.[1],
                                    familyId: item.familyId?.replaceAll(
                                        /['"]+/g,
                                        ''
                                    ),
                                }
                            })
                    )
                    duplicateFilesFromPreviousUploads
                        ?.filter((item) => !item?.imported)
                        ?.map((item) => {
                            return {
                                key: item.fileKey,
                                fileName: item.fileKey?.split(/_(.*)/s)?.[1],
                                familyId: item.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                ),
                            }
                        })?.length !== 0 && setShowDuplicateDialog(true)
                } else if (
                    duplicateFilesFromPreviousUploads.length !== 0 &&
                    duplicateFamilies?.length !== 0
                ) {
                    setDuplicateFileInstances(null)
                    setDuplicateFamilies(
                        allDuplicates
                            ?.filter((item) => !item?.imported)
                            ?.map((item) => {
                                return {
                                    key: item.fileKey,
                                    fileName: item.fileKey?.split(
                                        /_(.*)/s
                                    )?.[1],
                                    familyId: item.familyId?.replaceAll(
                                        /['"]+/g,
                                        ''
                                    ),
                                }
                            })
                            ?.filter((item, index) => {
                                return (
                                    allDuplicates
                                        ?.map((mapItem) =>
                                            mapItem['familyId']?.replaceAll(
                                                /['"]+/g,
                                                ''
                                            )
                                        )
                                        .indexOf(item['familyId']) === index
                                )
                            })
                    )
                    allDuplicates
                        ?.filter((item) => !item?.imported)
                        ?.map((item) => {
                            return {
                                key: item.fileKey,
                                fileName: item.fileKey?.split(/_(.*)/s)?.[1],
                                familyId: item.familyId?.replaceAll(
                                    /['"]+/g,
                                    ''
                                ),
                            }
                        })
                        ?.filter((item, index) => {
                            return (
                                allDuplicates
                                    ?.map((mapItem) =>
                                        mapItem['familyId']?.replaceAll(
                                            /['"]+/g,
                                            ''
                                        )
                                    )
                                    .indexOf(item['familyId']) === index
                            )
                        })?.length !== 0 && setShowDuplicateDialog(true)
                }
                setFileExtractionLoading(true)
            } else {
                setFileExtractionLoading(true)

                setAllUploadedFamilies(files?.userImportedFamilies)
                setItemToImportFile(uploadedPickerData?.filesUploaded?.[0])
            }
        },
        [uploadedPickerData, firmId, currentProjectId]
    )
    const closeImportExecuteDialog = React.useCallback(() => {
        setExecutedInstanceId(null)
        setIsImportCompleted(false)
        setShowAllFiles(false)
        setOverrideDialogType(undefined)
        setPublishInstanceId(null)
        setImportedFilesToBePublished(false)
    }, [])

    const savedStateValues = React.useMemo(() => {
        if (userId && currentProjectId) {
            return (
                getFromLocalStorage(userId, currentProjectId) ?? {
                    showImportActionBarState: {
                        importActionBar: false,
                    },
                }
            )
        }
    }, [userId, currentProjectId])

    const updatePersistentStateValues = React.useCallback(
        (propKey: string, inputValue: boolean | any) => {
            saveToLocalStorage(propKey, inputValue, userId, currentProjectId)
        },
        [userId, currentProjectId]
    )
    const handleActionBarStateChange = React.useCallback(
        (stateKey: string, newValue: any, persist?: boolean) => {
            setImportActionBarStateValue((prevWorkspaceActionBarState) => {
                const newState = setNestedObjectPropertyValue(
                    stateKey,
                    newValue,
                    prevWorkspaceActionBarState
                )
                return newState
            })
            if (persist) {
                updatePersistentStateValues(stateKey, newValue)
            }
        },
        [updatePersistentStateValues]
    )
    React.useEffect(() => {
        updatePersistentStateValues(
            'showImportActionBarState',
            savedStateValues?.showImportActionBarState
        )

        setImportActionBarStateValue({
            ...savedStateValues,
        })
    }, [savedStateValues, updatePersistentStateValues])

    React.useEffect(() => {
        if (
            workResultAssemblyId &&
            workresultNodes === undefined &&
            currentProjectId
        ) {
            getElementNodes()
        }
    }, [workResultAssemblyId, workresultNodes, currentProjectId])
    React.useEffect(() => {
        setProjectSettings(
            projectData?.getProject?.projectSettings as ProjectSettings
        )
    }, [projectData])

    const executingFilesTitle = React.useMemo(() => {
        return (
            filesData?.fileInfo
                ?.filter((item) => !item?.imported)
                ?.map((item) => item.title!) ?? []
        )
    }, [filesData, executedInstanceId])
    const handleImportingFilesView = React.useCallback(
        (value: boolean) => {
            if (executingFilesTitle && executingFilesTitle?.length !== 0) {
                setShowAllFiles(value)
            }
        },
        [executingFilesTitle]
    )
    React.useEffect(() => {
        setSelectedElementIdentifier?.(undefined)
        setCategoryElementStates?.({})
        getImportedFiles({
            variables: {
                projectId: currentProjectId ?? contentTeamProjectId,
            },
        })
    }, [
        currentProjectId,
        setCategoryElementStates,
        setSelectedElementIdentifier,
        contentTeamProjectId,
    ])

    React.useEffect(() => {
        const newUploadedFiles =
            filesData?.fileInfo
                ?.filter((item) => !item.imported)
                ?.map((item) => {
                    return item.title!
                }) ?? []
        if (newUploadedFiles?.length !== 0) {
            setOverRiddenPaths(undefined)
        }
    }, [filesData])
    React.useEffect(() => {
        uploadedPickerData &&
            itemToImportFile &&
            !showDuplicateDialog &&
            !duplicateFilesLoading &&
            importFilesQuery({
                variables: {
                    input: {
                        userFiles: uploadedPickerData?.filesUploaded?.map(
                            (item) => {
                                return {
                                    key: item?.key!,
                                    fileName: item?.key?.split(/_(.*)/s)?.[1]!,
                                }
                            }
                        ),
                        projectId: currentProjectId!,
                        firmId: firmId!,
                    },
                },
            })
    }, [
        itemToImportFile,
        uploadedPickerData,
        showDuplicateDialog,
        duplicateFilesLoading,
        currentProjectId,
    ])

    const saveToLocalStorage = (
        propKey: string,
        inputValue: boolean | any,
        userId: string | undefined,
        projectId: string | undefined
    ) => {
        if (userId) {
            const saved = getLocalStorageValue(
                localStorageItemKey(projectId ?? ''),
                userId,
                '',
                localStorageKey(userId)
            )
            const pastItems = saved !== '' ? JSON.parse(saved as string) : {}

            updateKpMainLocalStore({
                currentUserId: userId,
                pageKey: localStorageKey(userId),
                itemKey: localStorageItemKey(projectId ?? ''),
                itemValue: JSON.stringify(
                    setNestedObjectPropertyValue(propKey, inputValue, pastItems)
                ),
            })
        }
    }

    const leftWidgets = React.useMemo(
        (): ImportPageActionBarWidget[][] => [
            [
                {
                    label: 'Add Files For Import',
                    component: (
                        <ImportDocumentRow
                            handleFilestackLoading={handleFilestackLoading}
                            handlePickerDoneTransfer={handlePickerDoneTransfer}
                            calledFrom="header"
                            isBPImport={isBPImport}
                            showGlobalSnackbar={showGlobalSnackbar}
                        />
                    ),
                },
            ],

            [
                {
                    label: 'Start Import',
                    component: (
                        <Button
                            role="button"
                            type="button"
                            onClick={startImport}
                            variant="contained"
                            color="default"
                            disabled={isImportDisabled}
                            disableElevation
                            data-testid={`startImport-button`}
                            className={clsx(
                                'startImoprt',
                                isImportDisabled
                                    ? classes.workspaceButtonDisabled
                                    : classes.workspaceButton
                            )}
                            aria-label="Start Import"
                        >
                            Start Import
                        </Button>
                    ),
                },
            ],
        ],
        [startImport, filesData, isBPImport]
    )
    React.useEffect(() => {
        if (!projectLoading && !!projectData && !!projectData.getProject) {
            setCurrentPageTitle(projectData?.getProject.name ?? '')
        }
        updateBrowserTitle?.(
            projectData?.getProject?.name
                ? `${projectData?.getProject?.name} - Import`
                : 'Office Master Import'
        )
    }, [setCurrentPageTitle, projectLoading, projectData, updateBrowserTitle])

    React.useEffect(() => {
        if (
            currentProjectId &&
            currentProjectId !==
                currentUserActiveFirmResponse?.myActiveFirm
                    ?.bestPracticeProjectId
        ) {
            setCustomActionBar(
                <ImportPageActionBar
                    currentState={importActionBarStateValue}
                    onStateChange={handleActionBarStateChange}
                    left={leftWidgets}
                />
            )
        } else if (isBPImport) {
            setCustomActionBar?.(
                <ImportBPHeader
                    isImportDisabled={isImportDisabled}
                    handleFilestackLoading={handleFilestackLoading}
                    handlePickerDoneTransfer={handlePickerDoneTransfer}
                    startImport={startImport}
                    showGlobalSnackbar={showGlobalSnackbar}
                    downloadMasterSpecStyleTemplate={
                        downloadMasterSpecStyleTemplate
                    }
                />
            )
        }
    }, [
        leftWidgets,
        setCustomActionBar,
        importActionBarStateValue,
        isImportDisabled,
        isBPImport,
        currentProjectId,
    ])

    React.useEffect(() => {
        if (
            !(familyPreviewLoading || productTypePreviewLoading) &&
            filesData &&
            !fileExtractionLoading &&
            filesData?.fileInfo?.length !== 0 &&
            (filesProgressData?.length === 0 || filesProgressData === undefined)
        ) {
            if (importPreviewData === undefined && !selectedProductTypeName) {
                setSelectedProductTypeName(undefined)
                if (
                    filesData?.fileInfo?.filter(
                        (item) =>
                            item?.fileKey === selectedFileForPreview?.fileKey
                    )?.length === 0
                ) {
                    handleSelectFileForPreview(
                        filesData?.fileInfo?.[0]?.fileKey
                    )
                }
            } else {
                if (
                    filesData?.fileInfo?.filter(
                        (itemFileInfo) =>
                            itemFileInfo?.title ===
                            importPreviewData?.sectionPreview?.title
                    )?.length === 0 &&
                    !selectedProductTypeName
                ) {
                    setSelectedProductTypeName(undefined)
                    if (
                        filesData?.fileInfo?.filter(
                            (item) =>
                                item?.fileKey ===
                                selectedFileForPreview?.fileKey
                        )?.length === 0
                    ) {
                        handleSelectFileForPreview(
                            filesData?.fileInfo?.[0]?.fileKey
                        )
                    }
                }
            }
        }
    }, [
        filesData,
        importPreviewData,
        selectedProductTypeName,
        filesProgressData,
        fileExtractionLoading,
        selectedFileForPreview,
        familyPreviewLoading,
        currentUserActiveFirmResponse,
        productTypePreviewLoading,
    ])

    React.useEffect(() => {
        if (
            !(
                fileExtractionLoading ||
                duplicateFilesLoading ||
                currentUserActiveFirmLoading
            ) &&
            !selectedFile?.imported &&
            !filesData?.fileInfo?.some(
                (item) => item?.fileKey === selectedFile?.fileKey
            )
        ) {
            const uploadedSelectedFile = filesData?.fileInfo?.filter(
                (item) => item?.familyId === selectedFile?.familyId
            )?.[0]
            setSelectedFile(uploadedSelectedFile)
            setSelectedFileForPreview(uploadedSelectedFile)
        }
    }, [
        fileExtractionLoading,
        duplicateFilesLoading,
        currentUserActiveFirmLoading,
    ])

    React.useEffect(() => {
        const allFilesUploaded = filesData?.fileInfo?.filter(
            (item) => !item?.imported
        )
        if (allFilesUploaded?.length !== 0) {
            let replacementFamilies: CheckForDuplicateFilesInAssemblyInput[] = []
            allFilesUploaded?.map((item) =>
                item?.associations?.map(
                    (item) => item && replacementFamilies?.push(item)
                )
            )
            let replacementsProductType: CheckForDuplicateFilesInAssemblyInput[] = []
            allFilesUploaded?.map((item) =>
                item?.productTypeInfo?.map(
                    (itemInner) =>
                        itemInner?.associations?.map(
                            (item) =>
                                item && replacementsProductType?.push(item)
                        )!
                )
            )

            setFamiliesToReplace([
                ...replacementFamilies?.filter(
                    (item) => item?.isForReplacement
                ),
                ...replacementsProductType?.filter(
                    (item) => item?.isForReplacement
                ),
            ])
            setFamiliesToAdd([
                ...replacementFamilies?.filter(
                    (item) => !item?.isForReplacement
                ),
                ...replacementsProductType?.filter(
                    (item) => !item?.isForReplacement
                ),
            ])
        }
    }, [filesData])

    const associationWarningContent = React.useMemo(() => {
        const notMatchingAssemblies =
            matchAssemblyAssociationsData
                ?.matchAssemblyAssociationsWithExistingVersions?.results
        return (
            <>
                {!!notMatchingAssemblies && (
                    <span className={classes.overRideContainer}>
                        <Typography
                            variant="body1"
                            className={classes.overRideHeadingImportTop}
                        >
                            The following Specpoint Families do not have
                            matching associations in the {elementsContainerType}
                            . In order to import, all versions of the Families
                            must have matching assembly associations. Please
                            remove associations before proceeding to import:
                        </Typography>
                        <GridContainer
                            className={classes.overRideImportHeading}
                        >
                            <GridItem
                                className={clsx(
                                    classes.familiyColumn,
                                    classes.familyColumnAssociation
                                )}
                            >
                                Family
                            </GridItem>
                            <GridItem className={classes.assemblyColumn}>
                                {' '}
                                Not Matching Assemblies
                            </GridItem>
                        </GridContainer>
                        {notMatchingAssemblies
                            ?.filter(function (value, index, array) {
                                return array.indexOf(value) === index
                            })
                            ?.map((item, index) => {
                                return (
                                    <GridContainer
                                        className={classes.overRideFamilies}
                                        key={index}
                                    >
                                        <GridItem
                                            className={clsx(
                                                classes.familiyColumn,
                                                classes.familyColumnAssociation
                                            )}
                                        >
                                            {item?.familyName}{' '}
                                        </GridItem>
                                        <GridItem
                                            className={clsx(
                                                classes.assemblyColumn,
                                                classes.assemblyColumnContent
                                            )}
                                        >
                                            {item?.notMatchingAssemblyTreePaths?.map(
                                                (assembly, assemblyIndex) => (
                                                    <>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                            }}
                                                        >
                                                            <span>{`${
                                                                assemblyIndex +
                                                                1
                                                            }.`}</span>
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            >
                                                                {assembly}
                                                            </span>
                                                        </div>
                                                    </>
                                                )
                                            )}
                                        </GridItem>
                                    </GridContainer>
                                )
                            })}{' '}
                    </span>
                )}
            </>
        )
    }, [matchAssemblyAssociationsData, showAssociationWarningDialog])

    const importDialogContent = React.useMemo(() => {
        return (
            <>
                {familiesToReplace && familiesToReplace?.length !== 0 && (
                    <span className={classes.overRideContainer}>
                        <Typography
                            variant="body1"
                            className={classes.overRideHeadingImportTop}
                        >
                            The following Specpoint Families will be overwritten
                            with this import in the {elementsContainerType}:
                        </Typography>
                        <GridContainer
                            className={classes.overRideImportHeading}
                        >
                            <GridItem className={classes.familiyColumn}>
                                Family
                            </GridItem>
                            <GridItem className={classes.assemblyColumn}>
                                {' '}
                                Assembly
                            </GridItem>
                        </GridContainer>
                        {familiesToReplace
                            ?.filter(function (value, index, array) {
                                return array.indexOf(value) === index
                            })
                            ?.map((item, index) => {
                                return (
                                    <GridContainer
                                        className={classes.overRideFamilies}
                                        key={index}
                                    >
                                        <GridItem
                                            className={classes.familiyColumn}
                                        >
                                            {item?.familyName}{' '}
                                        </GridItem>
                                        <GridItem
                                            className={classes.assemblyColumn}
                                        >
                                            {' '}
                                            {item?.assemblyName
                                                ? item?.assemblyName
                                                : item?.treePath
                                                      ?.split('|')
                                                      .pop()}
                                        </GridItem>
                                    </GridContainer>
                                )
                            })}{' '}
                    </span>
                )}
                {'\n'}
                {familiesToAdd && familiesToAdd?.length !== 0 && (
                    <span className={classes.overRideContainer}>
                        <Typography
                            variant="body1"
                            className={classes.overRideHeadingImportBottom}
                        >
                            The following Specpoint Families will be added to
                            the {elementsContainerType}:
                        </Typography>
                        <GridContainer
                            className={classes.overRideImportHeading}
                        >
                            <GridItem className={classes.familiyColumn}>
                                Family
                            </GridItem>
                            <GridItem className={classes.assemblyColumn}>
                                {' '}
                                Assembly
                            </GridItem>
                        </GridContainer>
                        {familiesToAdd
                            ?.filter(function (value, index, array) {
                                return array.indexOf(value) === index
                            })
                            ?.map((item, index) => {
                                return (
                                    <GridContainer
                                        className={classes.overRideFamilies}
                                        key={index}
                                    >
                                        <GridItem
                                            className={classes.familiyColumn}
                                        >
                                            {item?.familyName}{' '}
                                        </GridItem>
                                        <GridItem
                                            className={classes.assemblyColumn}
                                        >
                                            {' '}
                                            {item?.assemblyName
                                                ? item?.assemblyName
                                                : item?.treePath
                                                      ?.split('|')
                                                      .pop()}
                                        </GridItem>
                                    </GridContainer>
                                )
                            })}{' '}
                    </span>
                )}
            </>
        )
    }, [familiesToReplace, filesData, familiesToAdd, elementsContainerType])
    React.useEffect(() => {
        if (!filesData || filesData?.fileInfo?.length === 0) {
            setImportPreviewData(undefined)
            setPreviewInstanceId(null)
        }
    }, [filesData, filesData?.fileInfo])
    const [selectedTab, setSelectedTab] = React.useState<number>(1)
    const handleTabChange = (
        _event: React.ChangeEvent<{}>,
        newValue: number
    ) => {
        setSelectedTab(newValue)
    }
    const handleGuideSelectionClick = (
        fileKey: string,
        label: string,
        value: boolean,
        points: number
    ) => {
        let newValueScore: number = 0
        let newTotalSteps: number = 0
        const updatedFilesData = filesData?.fileInfo?.map((item) => {
            if (item.fileKey === fileKey) {
                newValueScore = item?.importGuideInfo?.valueScore as number
                if (
                    item?.importGuideInfo?.[label as keyof ImportGuideInfo] !==
                    value
                ) {
                    if (value === true) {
                        newValueScore =
                            (item?.importGuideInfo?.valueScore as number) +
                            points
                    } else if (
                        value === false &&
                        (item?.importGuideInfo?.valueScore as number) > 0 &&
                        item?.importGuideInfo?.[
                            label as keyof ImportGuideInfo
                        ] !== null
                    ) {
                        newValueScore =
                            (item?.importGuideInfo?.valueScore as number) -
                            points
                    }
                }
                newTotalSteps = item?.importGuideInfo?.totalSteps as number
                if (
                    item?.importGuideInfo?.[label as keyof ImportGuideInfo] !==
                    value
                ) {
                    if (value === true) {
                        newTotalSteps =
                            (item?.importGuideInfo?.totalSteps as number) + 1
                    } else if (
                        value === false &&
                        (item?.importGuideInfo?.totalSteps as number) > 0 &&
                        item?.importGuideInfo?.[
                            label as keyof ImportGuideInfo
                        ] !== null
                    ) {
                        newTotalSteps =
                            (item?.importGuideInfo?.totalSteps as number) - 1
                    }
                }
                return {
                    ...item,
                    importGuideInfo: {
                        ...(item.importGuideInfo as ImportGuideInfo),
                        [label]: value,
                        valueScore: newValueScore,
                        totalSteps: newTotalSteps,
                    },
                }
            } else {
                return item
            }
        })
        setFilesData({
            ...filesData,
            fileInfo: shortedImportTableData(updatedFilesData!),
        })
        const updatedSelectedFile = {
            ...selectedFile,
            importGuideInfo: {
                ...(selectedFile?.importGuideInfo as ImportGuideInfo),
                [label]: value,
                valueScore: newValueScore,
                totalSteps: newTotalSteps,
            },
        }
        setSelectedFile(updatedSelectedFile)
        setSelectedFileForPreview(updatedSelectedFile)
    }
    return (
        <>
            <div className={classes.container} data-testid="dvProjectImport">
                <GridContainer
                    direction="row"
                    className={classes.projectImportContainer}
                >
                    <ImportPageTable
                        showAddDialog={showImportDialog}
                        handleShowRemoveDialog={handleShowRemoveDialog}
                        handleShowIssueDialog={handleShowIssueDialog}
                        handleChangeFileStatus={handleChangeFileStatus}
                        handleDuplicateFileChangeFileStatus={
                            handleChangeDuplicateFileFileStatus
                        }
                        actionBarCollapsed={actionBarCollapsed}
                        showDuplicateDialog={showDuplicateDialog}
                        selectedFile={selectedFile}
                        handleSelectFileForPreview={handleSelectFileForPreview}
                        importPreviewTitle={
                            selectedRowType === 'Family'
                                ? selectedFile?.title
                                : selectedProductTypeName
                        }
                        loading={
                            fileExtractionLoading ||
                            duplicateFilesLoading ||
                            currentUserActiveFirmLoading
                        }
                        handleClickSetAssociationButton={
                            handleClickSetAssociationButton
                        }
                        instanceId={instanceId!}
                        handleExpandRow={handleExpandRow}
                        filesData={filesData}
                        progressFilesData={filesProgressData}
                        imageClickArea={
                            <ImportDocumentRow
                                handleFilestackLoading={handleFilestackLoading}
                                handlePickerDoneTransfer={
                                    handlePickerDoneTransfer
                                }
                                showGlobalSnackbar={showGlobalSnackbar}
                                isBPImport={isBPImport}
                                calledFrom="image"
                            />
                        }
                        isBPImport={isBPImport}
                        addFileButton={
                            <ImportDocumentRow
                                handleFilestackLoading={handleFilestackLoading}
                                handlePickerDoneTransfer={
                                    handlePickerDoneTransfer
                                }
                                showGlobalSnackbar={showGlobalSnackbar}
                                calledFrom="table"
                                isBPImport={isBPImport}
                            />
                        }
                    />
                    <div className={clsx(classes.importDetailsWrapper)}>
                        {!selectedFile?.imported === false ||
                            (selectedFile?.imported !== undefined && (
                                <Tabs
                                    value={selectedTab}
                                    onChange={handleTabChange}
                                    aria-label="Guide/Preview Tab"
                                    classes={{
                                        indicator: classes.tabsIndicator,
                                    }}
                                >
                                    <Tab
                                        label="GUIDE"
                                        {...a11yProps(0)}
                                        classes={{
                                            root: classes.tabButtonsRoot,
                                            selected: classes.selectedTab,
                                        }}
                                        tabIndex={0}
                                    />
                                    <Tab
                                        label="PREVIEW"
                                        {...a11yProps(1)}
                                        classes={{
                                            root: classes.tabButtonsRoot,
                                            selected: classes.selectedTab,
                                        }}
                                        tabIndex={0}
                                    />
                                </Tabs>
                            ))}
                        {!selectedFile?.imported && selectedTab === 0 ? (
                            <div id="simple-tabpanel-0">
                                <ImportGuidePage
                                    selectedFile={selectedFile}
                                    isBPImport={isBPImport}
                                    selectedRowType={selectedRowType}
                                    selectedTypeName={
                                        selectedRowType === 'Family'
                                            ? selectedFile?.title
                                            : selectedProductTypeName
                                    }
                                    isSelectedFileExisting={filesData?.fileInfo?.some(
                                        (item) =>
                                            item?.fileKey ===
                                            selectedFile?.fileKey
                                    )}
                                    handleGuideSelectionClick={
                                        handleGuideSelectionClick
                                    }
                                />
                            </div>
                        ) : (
                            <div id="simple-tabpanel-1">
                                <ImportPreviewSection
                                    actionBarCollapsed={actionBarCollapsed}
                                    previewLoading={
                                        familyPreviewLoading ||
                                        productTypePreviewLoading
                                    }
                                    isBPImport={isBPImport}
                                    importPreviewData={importPreviewData}
                                    settings={projectSettings}
                                    selectedRowType={selectedRowType}
                                    selectedTypeName={
                                        selectedRowType === 'Family'
                                            ? selectedFile?.title
                                            : selectedProductTypeName
                                    }
                                    selectedTextType={
                                        selectedRowType === 'Family'
                                            ? undefined
                                            : selectedFile?.productTypeInfo?.filter(
                                                  (item) =>
                                                      item?.name ===
                                                      selectedProductTypeName
                                              )?.[0]?.textType
                                    }
                                    isSelectedFileImported={
                                        selectedFile?.imported
                                    }
                                />
                            </div>
                        )}
                    </div>
                </GridContainer>
            </div>
            <Backdrop
                className={classes.backdrop}
                open={
                    (projectLoading ||
                        discardFileLoading ||
                        discardFileLoadingBP ||
                        getFilesLoading) ??
                    false
                }
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <NavPrompt
                showPrompt={
                    filesData !== undefined &&
                    filesData?.fileInfo?.filter((item) => !item.imported)
                        ?.length !== 0 &&
                    !showWarningDialog
                }
                preferredMessage={
                    'Are you sure you want to navigate away from this page? Your changes will not be saved.'
                }
                confirmText="OK"
                cancelText="Cancel"
                title="Discard Changes"
                buttonColor="rgb(167, 137, 102)"
                isImportTab
            />
            {!!(executedInstanceId || publishIntanceId) && (
                <ImportExecutionProgress
                    handleChangeFileStatus={handleChangeExecuteStatus}
                    instanceId={executedInstanceId ?? ''}
                    handleDialogClose={closeImportExecuteDialog}
                    title={executingFilesTitle!}
                    showAllFiles={showAllFiles}
                    handleImportingFilesView={handleImportingFilesView}
                    isImportCompleted={isImportCompleted}
                    isBPImport={isBPImport}
                    importedFilesToBePublished={importedFilesToBePublished}
                    publishInstanceId={publishIntanceId ?? ''}
                    filesToPublish={filesToPublish}
                />
            )}
            <ConfirmationDialog
                dialogHeading="Duplicate Detected"
                openDialog={showDuplicateDialog}
                removeHeaderBorder
                handleDialogClose={cancelFileUpload}
                dialogActionCallback={handleContinueImport}
                contentNode={
                    <>
                        Family with the following ID (
                        {duplicateFilesMessage?.replace(/['"]+/g, '')}) already
                        exist
                    </>
                }
                cancelText="Cancel"
                confirmText="Discard"
                size="small"
                confirmMessage="Would you like to discard you current upload(s)?"
            />
            <ConfirmationDialog
                dialogHeading="Set Associations"
                openDialog={showEmptyAssociationDialog}
                handleDialogClose={handleCloseEmptyAssociationDialog}
                dialogActionCallback={openAssociationDialog}
                contentNode={
                    <>
                        Please set your associations first before starting
                        import.
                    </>
                }
                cancelText="Cancel"
                confirmText="Proceed"
                size="small"
                confirmMessage=""
            />

            <ConfirmationDialog
                dialogHeading={
                    overrideDialogType === 'Import'
                        ? 'Confirm Import'
                        : 'Import Will Override'
                }
                openDialog={showOverrideDialog}
                headerColor="#304959"
                contentOverflow={overrideDialogType === 'Import'}
                handleDialogClose={cancelSaveAssociation}
                dialogActionCallback={(e) =>
                    overrideDialogType === 'Import'
                        ? handleStartExecution(e, true, false)
                        : handleConfirmAssociation()
                }
                calledForImportExecution={
                    overrideDialogType === 'Import' && !isBPImport
                }
                dialogActionCallbackForImportOnly={(e) =>
                    handleStartExecution(e, false, false)
                }
                removeFooterBorder={
                    overrideDialogType === 'Import' ? false : true
                }
                contentNode={
                    overrideDialogType === 'Import' ? (
                        importDialogContent
                    ) : (
                        <span className={classes.overRideContainer}>
                            <Typography
                                variant="body1"
                                className={classes.overRideHeading}
                            >
                                The following Specpoint families:
                            </Typography>
                            {overRiddenPaths
                                ?.filter(function (item, position) {
                                    return (
                                        overRiddenPaths.indexOf(item) ==
                                        position
                                    )
                                })
                                ?.map((item, index) => {
                                    return (
                                        <p
                                            className={classes.overRideText}
                                            key={index}
                                        >
                                            {item}
                                        </p>
                                    )
                                })}{' '}
                        </span>
                    )
                }
                showImportPublishButton={
                    overrideDialogType === 'Import' && isBPImport
                }
                dialogActionCallbackForImportPublish={handleImportWithPublish}
                cancelText="Cancel"
                confirmText={
                    overrideDialogType === 'Import'
                        ? isBPImport
                            ? 'Import'
                            : 'Import + Add'
                        : 'Proceed'
                }
                size={overrideDialogType === 'Import' ? 'large' : 'default'}
                confirmMessage={
                    overrideDialogType === 'Import' && !isBPImport
                        ? 'Would you like to auto-add these elements in the Project?'
                        : ''
                }
            />
            <ConfirmationDialog
                dialogHeading={`Set Associations - ${selectedFile?.title}`}
                openDialog={showAssociationDialog}
                handleDialogClose={hideAssociation}
                dialogActionCallback={handleSaveAssociation}
                headerColor="#304959"
                contentNode={
                    selectedFile && selectedFilesAssociations ? (
                        <SetAssociations
                            selectedFile={selectedFile}
                            projectId={currentProjectId!}
                            getAssociationLists={getAssociationLists}
                            resetElements={refreshElementPanel}
                            handleResetElements={handleResetElements}
                            isBPImport={isBPImport}
                        />
                    ) : (
                        <></>
                    )
                }
                cancelText="Cancel"
                confirmText="Save"
                size="large"
                confirmMessage=""
            />

            <ConfirmationDialog
                dialogHeading="Discard Changes"
                openDialog={
                    !!removeFileData &&
                    !discardFileLoading &&
                    !discardFileLoadingBP
                }
                handleDialogClose={() => setRemoveFileData(undefined)}
                dialogActionCallback={handleClickRemove}
                removeHeaderBorder
                contentNode={
                    <>
                        {isRemovingFileImported
                            ? 'Are you sure you want to permanently discard your imported document?'
                            : 'Are you sure you want to permanently discard your uploaded document for Import?'}
                    </>
                }
                cancelText="Cancel"
                confirmText="OK"
                size="small"
                confirmMessage="Select OK to continue, or Cancel to keep changes."
            />

            {showAssociationWarningDialog && isBPImport && (
                <ConfirmationDialog
                    dialogHeading={`Import Error`}
                    openDialog={showAssociationWarningDialog}
                    handleDialogClose={handleAssociationWarningDialog}
                    headerColor="#304959"
                    contentNode={associationWarningContent}
                    cancelText="Close"
                    confirmText=""
                    confirmMessage=""
                    size="large"
                />
            )}

            {isBPImport && (
                <>
                    {isVersionCriteriaEnabled ? (
                        <ImportDuplicateVersionDialog
                            showDuplicateImportDialoge={
                                isVersionCriteriaEnabled &&
                                showDuplicateImportDialoge
                            }
                            setShowDuplicateImportDialouge={
                                setShowDuplicateImportDialouge
                            }
                            startImport={handleStartImportExecution}
                            familyVersionsToImport={familyVersionsToImport}
                            setFamilyVersionsToImport={
                                setFamilyVersionsToImport
                            }
                            duplicateOfficeMasterImportFamilies={
                                duplicateOfficeMasterImportFamilies
                            }
                            showGlobalSnackbar={showGlobalSnackbar}
                        />
                    ) : (
                        <ConfirmationDialog
                            dialogHeading="A Duplicate Family Exists"
                            openDialog={
                                !isVersionCriteriaEnabled &&
                                showDuplicateImportDialoge
                            }
                            handleDialogClose={() =>
                                setShowDuplicateImportDialouge(false)
                            }
                            dialogActionCallback={handleDeleteElement}
                            removeHeaderBorder
                            contentNode={
                                ' This action will permanently replace the existing imported Family and assembly associations from the Element Library and clear all Work Items.'
                            }
                            cancelText="Cancel"
                            confirmText="Yes"
                            size="small"
                            confirmMessage="Are you sure you want to proceed?"
                        />
                    )}
                </>
            )}

            {showWarningDialog && selectedFile && warningDialogType && (
                <ImportIssuesDialog
                    selectedFile={selectedFile}
                    warningDialogType={warningDialogType}
                    isDisplayed={showWarningDialog}
                    dialogDisplayHandler={handleIssueDialogDisplay}
                />
            )}
        </>
    )
}

export default ProjectImportPage
